<template>
    <div id="coll" style="width: 90%">
        <Breadcrumb></Breadcrumb>
        <!--按钮组-->
        <div style="text-align: right;">
            <el-button type="info" size="small">一键翻译</el-button>
            <el-button type="warning" size="small" @click="save(0)">保存</el-button>
            <el-button type="primary" size="small" @click="release">发布</el-button>
        </div>
        <div id="main" style="overflow: hidden">
            <div style="background-color: white;margin-top: 15px;" class="t_plane self_el_item_form">
                <el-container>
                    <!-- 头部 -->
                    <el-header style="color: #A2A2A2;padding-top: 20px;height: 30px"><strong>基本信息</strong></el-header>
                    <!-- 分割线 -->
                    <el-divider margin="8px,0"></el-divider>
                    <el-main style="padding-left: 100px">
                        <el-form ref="jbxxForm" :model="jbxxForm" label-width="80px" :rules="rules">
                            <el-form-item label="店铺帐号" prop="account">
                                <el-select clearable  v-model="jbxxForm.shopName" placeholder="---请选择店铺---" style="width: 300px" size="small" @change="shopNameChange">
                                    <el-option
                                            v-for="item in claimList"
                                            :key="item.shopId"
                                            :label="item.shopName"
                                            :value="item.shopId">{{item.shopName}}({{dictData['amazon_site'][item.amazonSite]}})
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="产品分类" prop="cpfl">
                                <el-input v-model="jbxxForm.cpfl" placeholder="请选择内容" style="width: 300px" size="small" ></el-input>
                                <el-button type="primary" style="margin-left: 15px" size="small" @click="getPlatTypeTree" >选择分类</el-button>
                                <el-row style="color: red">
                                    {{cascaderName}}
                                </el-row>
                            </el-form-item>
                            <el-form-item label="产品属性">
                                <div style="width: 400px;height: 200px;background-color: #EEEEEE;padding: 15px 25px 25px 60px">
                                    <el-form-item label="品牌" prop="brand">
                                        <el-select clearable  v-model="jbxxForm.brand" placeholder="请选择" style="width: 300px" size="small" @change="brandChange">
                                            <el-option
                                                    v-for="item in brandOption"
                                                    :key="item.brid"
                                                    :label="item.brand"
                                                    :value="item.brid">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item v-for="(cat,index) in catList" :label="cat.attrName" style="margin-top: 15px">
                                        <el-select clearable   v-model="selectValue[index]" placeholder="请选择" style="width: 300px" size="small" @change="materialChange($event,index)">
                                            <el-option
                                                    v-for="item in selectValueList[index]"
                                                    :key="item.valId"
                                                    :label="item.valName"
                                                    :value="item.valId">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </el-form-item>
                        </el-form>
                    </el-main>
                </el-container>

            </div>
            <!--xx信息-->
            <div style="background-color: white;margin-top: 15px" class="t_plane self_el_item_form">
                <el-container>
                    <!-- 头部 -->
                    <el-header style="color: #A2A2A2;padding-top: 20px;height: 30px"><strong>xx信息(注:下列信息,仅在此xxx生效)</strong>
                    </el-header>
                    <!-- 分割线 -->
                    <el-divider margin="8px,0"></el-divider>
                    <el-main style="padding-left: 100px">
                        <el-form ref="xxForm" :model="xxForm" label-width="80px">
                            <el-form-item label="XXX分类">
                                <TreeSelect :props="treeSelect" :options="dataList"  v-model="xxForm.typeNo" ref="childSelTree"
                                            style="width: 50%;margin-right: 10px" @getValue="getTreeNodeId"></TreeSelect>
                            </el-form-item>
                            <el-form-item label="来源URL">
                                <el-row>
                                    <el-col :span="1">
                                        <div style="font-size: 20px;background-color: #F7F7F7;text-align: center">1</div>
                                    </el-col>
                                    <el-input v-model="xxForm.defaultUrl" placeholder="请输入内容"
                                              style="width: 400px;margin-right: 20px" size="small"></el-input>
                                    <el-button type="primary" size="small">访问</el-button>
                                    <el-button icon="el-icon-plus" @click="addURL" size="small"></el-button>
                                </el-row>
                                <div v-for="(item, i) in xxForm.urls" :key="i">
                                    <el-col :span="1">
                                        <div style="font-size: 20px;background-color: #F7F7F7;text-align: center">{{i+2}}
                                        </div>
                                    </el-col>
                                    <el-input v-model="xxForm.urls[i]" placeholder="请输入内容"
                                              style="width: 400px;margin-right: 20px" size="small"></el-input>
                                    <el-button type="primary" size="small">访问</el-button>
                                    <el-button icon="el-icon-minus" @click="deletei(i)" size="small"></el-button>
                                </div>
                            </el-form-item>
                        </el-form>
                    </el-main>
                </el-container>
            </div>
            <!--产品信息-->
            <div style="background-color: white;margin-top: 15px" class="t_plane self_el_item_form">
                <el-container>
                    <!-- 头部 -->
                    <el-header style="color: #A2A2A2;padding-top: 20px;height: 30px"><strong>产品信息</strong></el-header>
                    <!-- 分割线 -->
                    <el-divider margin="8px,0"></el-divider>
                    <el-main style="padding-left: 100px">
                        <el-form ref="cpForm" :model="cpForm" label-width="100px" :rules="rules">
                            <el-form-item label="类型:">
                                <el-radio v-model="cpForm.sellType" label="01">单品</el-radio>
                                <el-radio v-model="cpForm.sellType" label="02">多品种</el-radio>
                            </el-form-item>
                            <el-form-item label="ParentSKU:">
                                <el-input v-model="cpForm.parentSku" placeholder="请输入内容"
                                          style="width: 400px;margin-right: 20px" size="small"></el-input>
                            </el-form-item>
                            <el-form-item label="产品标题:" prop="proTitle">
                                <el-input type="textarea" show-word-limit maxlength="60" v-model="cpForm.proTitle"
                                          placeholder="请输入内容" style="width: 400px;margin-right: 20px"></el-input>
                            </el-form-item>
                            <el-form-item label="产品描述:" prop="detail">
                                <el-input type="textarea" :rows="8" show-word-limit maxlength="3000"
                                          v-model="cpForm.detail" placeholder="请输入内容"
                                          style="width: 400px;margin-right: 20px"></el-input>
                            </el-form-item>
                        </el-form>
                    </el-main>
                </el-container>

            </div>
            <!--图片信息-->
            <div style="background-color: white;margin-top: 15px" class="t_plane self_el_item_form">
                <el-container>
                    <!-- 头部 -->
                    <el-header style="color: #A2A2A2;padding-top: 20px;height: 30px"><strong>图片信息</strong></el-header>
                    <!-- 分割线 -->
                    <el-divider margin="8px,0"></el-divider>
                    <el-main style="width: 100%">
                        <el-row>
                            <el-col :span="8">
                                <el-upload
                                        :show-file-list="false"
                                        class="upload-demo"
                                        action="#"
                                        multiple
                                        :http-request="requertUpload"
                                        :file-list="fileList"
                                        :before-upload="beforeUpload">
                                    <span style="margin-right: 15px">产品图片:</span>
                                    <el-button size="small" type="primary" >点击上传</el-button>
                                </el-upload>
                            </el-col>
                            <el-col :span="16" style="text-align: right">
                                <el-link type="primary">批量加水印</el-link>
                                <span style="margin-left: 15px;margin-right: 15px;color: #029ef3">|</span>
                                <el-link type="primary">改变图片大小</el-link>
                                <span style="margin-left: 15px;margin-right: 15px;color: #029ef3">|</span></span>
                                <el-link type="primary" @click="downloadZip">导出全部图片</el-link>
                            </el-col>
                        </el-row>
                        <el-row style="text-align: center">
                            <span style="color: #8a8a8a;">点击图片拖动,即可调整图片顺序![图片最多选择9张,已经选择了{{count}}张]</span>
                        </el-row>
                        <el-row>
                            <draggable @start="start" @end="end" :list="picList">
                                <el-col :span="2" v-for="(o, index) in picList" :key="index" :offset="1">
                                    <el-card :body-style="{ padding: '0px' }">
                                        <el-checkbox :label="index" @change="checked=>change(checked,index)"
                                                     v-model="o.checked">选择
                                        </el-checkbox>
                                        <el-popover trigger="hover" title="" placement="right" >
                                            <img :src="o.img"
                                                 style="width: 200px;height: 200px">
                                            <img slot="reference" :src="o.img" style="height: 100px;width: 100px">
                                        </el-popover>
                                        <el-row style="text-align: center;background-color: #F5F5F5">{{o.height}}x{{o.width}}</el-row>
                                        <div style="padding-top: 10px;padding-bottom: 10px">
                                            <el-row>
                                                <el-col :span="15">
                                                    <el-button type="text" class="button">在线美图</el-button>
                                                </el-col>
                                                <el-col :span="8">
                                                    <el-button type="text" class="button" @click="deletePic(index)">移除</el-button>
                                                </el-col>
                                            </el-row>
                                        </div>

                                    </el-card>
                                </el-col>

                            </draggable>
                        </el-row>
                        <el-row style="margin-top: 15px">
                            <span style="margin-right: 15px">尺码图片:</span>
                            <span style="margin-right: 15px;color: #8a8a8a">图片大小不能超过500k,像素不能超过2000*2000,图片最多选择一张</span>
                        </el-row>
                        <el-row style="margin-top: 15px" id="upload" v-show="uploadDis">
                            <el-upload
                                    :show-file-list="false"
                                    class="upload-demo"
                                    drag
                                    action="#"
                                    multiple style="width: 200px"
                                    :http-request="requertUploadSize">
                                <i class="el-icon-plus" style="font-size: 80px"></i>
                                <div class="el-upload__text"><strong style="font-size: 20px">添加图片</strong></div>
                            </el-upload>
                        </el-row>
                        <!--&lt;!&ndash;图片&ndash;&gt;-->
                        <el-row style="margin-top: 8px">
                            <draggable  :list="sizePicList">
                                <el-col :span="2" v-for="(o, index) in sizePicList" :key="index" :offset="1">
                                    <el-card :body-style="{ padding: '0px' }">
                                        <el-row>
                                            <el-col :span="20">
                                                <el-popover trigger="hover" title="" placement="right">
                                                    <img :src="o.img"
                                                         style="width: 200px;height: 200px">
                                                    <img slot="reference" :src="o.img" style="height: 100px;width: 150px">
                                                </el-popover>
                                            </el-col>
                                            <el-col :span="2" class="cursor">
                                                <i class="el-icon-error"  @click="deleteSiezPic"></i>
                                            </el-col>
                                        </el-row>
                                        <div style="padding-top: 3px;padding-bottom: 3px;text-align: center">
                                            <el-row>
                                                {{o.height}}x{{o.width}}
                                            </el-row>
                                        </div>
                                    </el-card>
                                </el-col>
                            </draggable>
                        </el-row>
                    </el-main>
                </el-container>

            </div>
            <!--变种信息-->
            <!--<div style="background-color: white;margin-top: 15px" class="t_plane self_el_item_form">-->
                <!--<el-container>-->
                    <!--&lt;!&ndash; 头部 &ndash;&gt;-->
                    <!--<el-header style="color: #A2A2A2;padding-top: 20px;height: 30px"><strong>变种信息</strong></el-header>-->
                    <!--&lt;!&ndash; 分割线 &ndash;&gt;-->
                    <!--<el-divider margin="8px,0"></el-divider>-->
                    <!--<el-main style="width: 100%">-->
                        <!--<el-row>-->
                            <!--<el-col :span="2">-->
                                <!--<span style="margin-right: 15px">变种主题:</span>-->
                            <!--</el-col>-->
                            <!--&lt;!&ndash; =2,不能添加&ndash;&gt;-->
                            <!--<div class="iconStyle" v-if="bzxx.testDynamicAttrList.length==2">-->
                                <!--<el-col :span="2" v-for="(item, index) in bzxx.AttrList" style="cursor: no-drop;color: #d0d3d6;">-->
                                    <!--<i class="el-icon-circle-plus-outline"></i>-->
                                    <!--<span>{{item.name}}</span>-->
                                <!--</el-col>-->
                            <!--</div>-->
                            <!--&lt;!&ndash; <2,可以点击添加&ndash;&gt;-->
                            <!--<div class="iconStyle2" v-if="bzxx.testDynamicAttrList.length<2">-->
                                <!--<el-col :span="2" v-for="(item, index) in bzxx.AttrList" style="color:  #4934b2;">-->
                                    <!--<i class="el-icon-circle-plus-outline" @click="addColorAndSize(item.name,index)"></i>-->
                                    <!--<span>{{item.name}}</span>-->
                                <!--</el-col>-->
                            <!--</div>-->
                            <!--&lt;!&ndash; <2 可以点击添加&ndash;&gt;-->
                            <!--<el-col :span="2" v-show="bzxx.testDynamicAttrList.length < 2">-->
                                <!--<el-button type="primary" style="margin-left: 15px" size="mini" @click="addAttr">添加自定义属性</el-button>-->
                            <!--</el-col>-->
                            <!--&lt;!&ndash; >=2 ,不能点击添加&ndash;&gt;-->
                            <!--<el-col :span="2" v-show="bzxx.testDynamicAttrList.length >= 2">-->
                                <!--<el-button type="primary" style="margin-left: 15px" size="mini" @click="addAttr" disabled>添加自定义属性</el-button>-->
                            <!--</el-col>-->
                        <!--</el-row>-->
                        <!--<div style="background-color: white;margin-top: 15px;width: 100%">-->
                            <!--<el-container style="border: 1px solid #DCDFE6;margin-bottom: 15px" v-for="(testDynamic, testDynamicIndex) in bzxx.testDynamicAttrList">-->
                                <!--&lt;!&ndash; 头部 &ndash;&gt;-->
                                <!--<el-header style="background-color: #F7F7F7;color: #A2A2A2;padding-top: 20px">-->
                                    <!--&lt;!&ndash;1:采集的属性名,2:Color,3:SIZE&ndash;&gt;-->
                                    <!--<el-col :span="5" v-if="testDynamic.attrType=='1'" >-->
                                        <!--<strong>变种主题{{testDynamicIndex+1}}:{{testDynamic.attrName}}</strong>-->
                                    <!--</el-col>-->
                                    <!--<el-col :span="5" v-else-if="testDynamic.attrType=='2'">-->
                                        <!--<strong>变种主题{{testDynamicIndex+1}}:Color</strong>-->
                                    <!--</el-col>-->
                                    <!--<el-col :span="5" v-else-if="testDynamic.attrType=='3'">-->
                                        <!--<strong>变种主题{{testDynamicIndex+1}}:Size</strong>-->
                                    <!--</el-col>-->
                                    <!--<el-col :span="19" style="text-align: right">-->
                                        <!--<span><el-link type="primary" @click="removeAttr(testDynamicIndex)">移除</el-link></span>-->
                                    <!--</el-col>-->
                                <!--</el-header>-->
                                <!--<el-main style="width: 100%">-->
                                    <!--<div>-->
                                        <!--&lt;!&ndash;颜色属性值,attrType为2才显示颜色列表&ndash;&gt;-->
                                        <!--<el-row style="margin-left: 4.16667%;" v-show="testDynamic.attrType=='2'">-->
                                            <!--<el-col :span="3" v-for="(item, index) in bzxx.colorList">-->
                                                <!--<el-checkbox v-model="item.checked" @change="addColorOrSizePic($event,item.attrValName,'2',testDynamicIndex,index)">-->
                                                    <!--<span class="spanStyle" :style="{background:item.colorCode,color:item.fontColor}">{{item.attrValName}}</span>-->
                                                <!--</el-checkbox>-->
                                            <!--</el-col>-->
                                        <!--</el-row>-->
                                        <!--&lt;!&ndash;Size属性值,attrType为3才显示Size列表&ndash;&gt;-->
                                        <!--<el-row style="margin-left: 4.16667%;" v-show="testDynamic.attrType=='3'">-->
                                            <!--<el-col :span="3" v-for="(item, index) in bzxx.sizeList">-->
                                                <!--<el-checkbox v-model="item.checked" @change="addColorOrSizePic($event,item.attrValName,'3',testDynamicIndex,index)">-->
                                                    <!--<span>{{item.attrValName}}</span>-->
                                                <!--</el-checkbox>-->
                                            <!--</el-col>-->
                                        <!--</el-row>-->
                                        <!--&lt;!&ndash;采集或者自己添加的属性值&ndash;&gt;-->
                                        <!--<el-row style="margin-top: 15px">-->
                                            <!--<el-col :span="4.5" v-for="(attrValItem,attrValIndex) in testDynamic.attrVal"  style="margin-left: 4.16667%" v-show="attrValItem.colorOrSize=='1'">-->
                                                <!--&lt;!&ndash;未编辑&ndash;&gt;-->
                                                <!--<el-row v-show="attrValItem.edit==false">-->
                                                    <!--<el-checkbox v-model="attrValItem.checked" @change="bzxxChecked($event,testDynamicIndex,attrValIndex)">-->
                                                        <!--<span>{{attrValItem.attrValName}}</span>-->
                                                    <!--</el-checkbox>-->
                                                    <!--<el-tooltip  effect="light" content="修改" placement="bottom-start" >-->
                                                        <!--<i class="el-icon-edit" style="margin-left: 5px" @click="iconEdit(testDynamicIndex,attrValIndex)"></i>-->
                                                    <!--</el-tooltip>-->
                                                <!--</el-row>-->
                                                <!--&lt;!&ndash;正在编辑&ndash;&gt;-->
                                                <!--<el-row v-show="attrValItem.edit!=false">-->
                                                    <!--<el-input type="text" v-model="attrValItem.backupName" placeholder="请输入内容" size="small" style="width: 110px"  maxlength="20" show-word-limit></el-input>-->
                                                    <!--<el-tooltip  effect="light" content="保存" placement="bottom-start" >-->
                                                        <!--<i class="el-icon-document-checked" style="margin-left: 5px" @click="iconSave(testDynamicIndex,attrValIndex)"></i>-->
                                                    <!--</el-tooltip>-->
                                                    <!--<el-tooltip effect="light" content="取消" placement="bottom-start">-->
                                                        <!--<i class="el-icon-circle-close" style="margin-left: 5px" @click="iconCancel(testDynamicIndex,attrValIndex)"></i>-->
                                                    <!--</el-tooltip>-->
                                                <!--</el-row>-->
                                            <!--</el-col>-->
                                        <!--</el-row>-->
                                        <!--&lt;!&ndash;添加属性值&ndash;&gt;-->
                                        <!--<el-row class="uploadBzxx">-->
                                            <!--<el-input type="text" v-model="testDynamic.attrValInputName" placeholder="请输入内容" style="width: 300px" size="small"  maxlength="20" show-word-limit></el-input>-->
                                            <!--<el-button type="primary" style="margin-left: 15px" size="small" @click="addValName(testDynamicIndex)">添加</el-button>-->
                                        <!--</el-row>-->
                                        <!--&lt;!&ndash;为checked=true的属性值添加一个上传组件&ndash;&gt;-->
                                        <!--<el-row class="uploadBzxx">-->
                                            <!--<el-col :span="3"  v-for="(item, index) in testDynamic.attrVal" v-if="item.checked==true && testDynamicIndex==0">-->
                                                <!--<el-row style="border: 1px solid #e8e8e8;width: 95px;">-->
                                                    <!--<div style="font-size: 12px" class="divOverflow">{{item.attrValName}}</div>-->
                                                <!--</el-row>-->
                                                <!--<el-upload-->
                                                        <!--class="upload-demo"-->
                                                        <!--drag-->
                                                        <!--action="#"-->
                                                        <!--multiple-->
                                                        <!--v-show="item.picUrl==''"-->
                                                        <!--:http-request="(value)=> bzxxUpload(item, value)"-->
                                                        <!--:show-file-list="false"-->
                                                        <!--:on-success="(value)=> handleBannerSuccess(testDynamic,index, value)">-->
                                                    <!--<el-row>-->
                                                        <!--<i class="el-icon-plus"></i>-->
                                                    <!--</el-row>-->
                                                    <!--<span>添加图片</span>-->
                                                <!--</el-upload>-->
                                                <!--<el-row v-show="item.picUrl!=''" class="bzxxDeleIcon">-->
                                                    <!--<el-col :span="13">-->
                                                        <!--<img :src="item.picUrl" style="width: 95px;height: 100px;">-->
                                                    <!--</el-col>-->
                                                    <!--<el-col :span="10" style="text-align: left;height: 30px">-->
                                                        <!--<i class="el-icon-error" style="cursor: pointer" @click="bzxxDeletePic(testDynamicIndex,index)"></i>-->
                                                    <!--</el-col>-->
                                                <!--</el-row>-->
                                            <!--</el-col>-->
                                        <!--</el-row>-->
                                    <!--</div>-->
                                <!--</el-main>-->
                            <!--</el-container>-->
                            <!--&lt;!&ndash;主题表格这里结束&ndash;&gt;-->
                            <!--&lt;!&ndash;<el-row style="color: #8a8a8a">&ndash;&gt;-->
                            <!--&lt;!&ndash;只有选择了折扣活动,填写限购,折扣才会生效,限购为"0",表示不限购&ndash;&gt;-->
                            <!--&lt;!&ndash;</el-row>&ndash;&gt;-->
                            <!--&lt;!&ndash;表格&ndash;&gt;-->
                            <!--<div style="margin-top: 20px">-->
                                <!--<el-table-->
                                        <!--:data="bzxx.tableData"-->
                                        <!--style="width: 100%" v-show="bzxx.tableData.length>0">-->
                                    <!--&lt;!&ndash;动态展示列是否显示&ndash;&gt;-->
                                    <!--<el-table-column-->
                                            <!--width="100" v-for="(item,index) in bzxx.testDynamicAttrList"-->
                                            <!--:label="item.attrName"-->
                                            <!--v-if="item.view==true"-->
                                            <!--:prop='index+""'>-->
                                    <!--</el-table-column>-->
                                    <!--<el-table-column-->
                                            <!--prop="name"-->
                                            <!--align="center"-->
                                            <!--width="150">-->
                                        <!--<template slot="header" slot-scope="scope">-->
                                            <!--<el-row>SKU</el-row>-->
                                            <!--<el-row>-->
                                                <!--<el-button type="text" @click="AutomaticGeneration">(自动生成)</el-button>-->
                                            <!--</el-row>-->
                                        <!--</template>-->
                                        <!--<template slot-scope="scope">-->
                                            <!--<el-input-->
                                                    <!--size="mini"-->
                                                    <!--v-model="scope.row.sku"-->
                                                    <!--style="width: 100px"/>-->
                                        <!--</template>-->
                                    <!--</el-table-column>-->
                                    <!--<el-table-column-->
                                            <!--prop="name"-->
                                            <!--align="center"-->
                                            <!--width="100">-->
                                        <!--<template slot="header" slot-scope="scope">-->
                                            <!--<el-row>价格</el-row>-->
                                            <!--<el-row>-->
                                                <!--<el-button type="text" @click="updatePriceDig">(修改)</el-button>-->
                                            <!--</el-row>-->
                                        <!--</template>-->
                                        <!--<template slot-scope="scope">-->
                                            <!--<el-input-->
                                                    <!--onkeyup="this.value=this.value.replace(/[^\d.]/g, '').replace(/^\.{1,}/g,'').replace(/^0{2,}/g,'').match(/^\d*(\.?\d{0,2})/g);"-->
                                                    <!--size="mini"-->
                                                    <!--v-model="scope.row.price"-->
                                                    <!--style="width: 70px"/>-->
                                        <!--</template>-->
                                    <!--</el-table-column>-->
                                    <!--<el-table-column>-->
                                        <!--<template slot="header" slot-scope="scope">-->
                                            <!--<el-row>-->
                                                <!--<el-col :span="12">-->
                                                    <!--<span>折扣活动</span>-->
                                                    <!--<span style="color: #029ef3">请选择</span>-->
                                                <!--</el-col>-->
                                                <!--<el-col :span="12" style="text-align: right">-->
                                                    <!--<span>限购</span>-->
                                                    <!--<el-input-->
                                                            <!--size="mini"-->
                                                            <!--v-model="bzxx.input"-->
                                                            <!--style="width: 100px"/>-->
                                                <!--</el-col>-->
                                            <!--</el-row>-->
                                        <!--</template>-->
                                        <!--<el-table-column-->
                                                <!--prop="province"-->
                                                <!--width="600">-->
                                            <!--<template slot="header" slot-scope="scope">-->
                                                <!--<el-row>-->
                                                    <!--<el-col :span="12">-->
                                                        <!--<div style="text-align: left;margin-left: 60px;">-->
                                                            <!--<span>促销价</span>-->
                                                            <!--<span style="color: #029ef3">(批量)</span>-->
                                                        <!--</div>-->
                                                    <!--</el-col>-->
                                                    <!--<el-col :span="12">-->
                                                        <!--<div style="text-align: right;margin-right: 60px;">-->
                                                            <!--<span>折扣</span>-->
                                                            <!--<span style="color: #029ef3">(批量)</span>-->
                                                        <!--</div>-->
                                                    <!--</el-col>-->
                                                <!--</el-row>-->
                                            <!--</template>-->
                                            <!--<template slot-scope="scope">-->
                                                <!--<el-row>-->
                                                    <!--<el-col :span="3">-->
                                                        <!--<el-switch-->
                                                                <!--v-model="scope.row.switchValue"-->
                                                                <!--active-color="#13ce66"-->
                                                                <!--inactive-color="#CCCCCC">-->
                                                        <!--</el-switch>-->
                                                    <!--</el-col>-->
                                                    <!--<el-col :span="7">-->
                                                        <!--<el-input-->
                                                                <!--size="mini"-->
                                                                <!--v-model="scope.row.promPrice"-->
                                                                <!--style="width: 150px"/>-->
                                                    <!--</el-col>-->
                                                    <!--<el-col :span="4" style="text-align: center">-->
                                                        <!--<span>或</span>-->
                                                    <!--</el-col>-->
                                                    <!--<el-col :span="10" style="text-align: right">-->
                                                        <!--<el-input-->
                                                                <!--size="mini"-->
                                                                <!--v-model="scope.row.discount"-->
                                                                <!--style="width: 150px"/>-->
                                                        <!--<span>%OFF(0折)</span>-->
                                                    <!--</el-col>-->
                                                <!--</el-row>-->
                                            <!--</template>-->
                                        <!--</el-table-column>-->
                                    <!--</el-table-column>-->
                                    <!--<el-table-column-->
                                            <!--prop="name"-->
                                            <!--align="center">-->
                                        <!--<template slot="header" slot-scope="scope">-->
                                            <!--<el-row>库存</el-row>-->
                                            <!--<el-row>-->
                                                <!--<el-button type="text" @click="updateInventDig">(修改)</el-button>-->
                                            <!--</el-row>-->
                                        <!--</template>-->
                                        <!--<template slot-scope="scope">-->
                                            <!--<el-input-->
                                                    <!--onkeyup="this.value=this.value.replace(/[^\d]/g, '').replace(/^0{2,}/g,'');"-->
                                                    <!--size="mini"-->
                                                    <!--v-model="scope.row.invent"-->
                                                    <!--style="width: 100px"/>-->
                                        <!--</template>-->
                                    <!--</el-table-column>-->
                                <!--</el-table>-->
                            <!--</div>-->
                            <!--&lt;!&ndash;多件优惠&ndash;&gt;-->
                            <!--<div style="margin-top: 15px">-->
                                <!--<el-row>-->
                                    <!--<el-col :span="2" style="text-align: right">-->
                                        <!--<span style="font-size: 12px">多件优惠:</span>-->
                                    <!--</el-col>-->
                                    <!--<el-col :span="20" v-show="bzxx.tableData2.length >0">-->
                                        <!--<el-form  :model="bzxx" ref="bzxx">-->
                                            <!--<el-table-->
                                                    <!--border-->
                                                    <!--:data="bzxx.tableData2"-->
                                                    <!--style="width: 100%"-->
                                                    <!--:header-cell-style="{background:'#eef1f6',color:'#595a5a'}">-->
                                                <!--<el-table-column-->
                                                        <!--label=""-->
                                                        <!--width="180"-->
                                                        <!--align="center">-->
                                                    <!--<template slot-scope="scope">-->
                                                        <!--<el-form-item  >-->
                                                            <!--<span>{{scope.row.sort+(scope.$index+1)}}</span>-->
                                                        <!--</el-form-item>-->
                                                    <!--</template>-->
                                                <!--</el-table-column>-->
                                                <!--<el-table-column-->
                                                        <!--label="购买数量"-->
                                                        <!--align="center">-->
                                                    <!--<template slot-scope="scope">-->
                                                        <!--<el-row>-->
                                                            <!--<el-col :span="9" style="text-align: left">-->
                                                                <!--<el-form-item  :prop="'tableData2.' + scope.$index + '.count1'" :rules='discounts.count1'>-->
                                                                    <!--<el-input-->
                                                                            <!--onkeyup="this.value=this.value.replace(/[^\d]/g,'');"-->
                                                                            <!--size="mini"-->
                                                                            <!--v-model="scope.row.count1"-->
                                                                            <!--style="width: 150px"/>-->
                                                                <!--</el-form-item>-->
                                                            <!--</el-col>-->
                                                            <!--<el-col :span="1" class="line">-->
                                                                <!--<el-form-item>-</el-form-item>-->
                                                            <!--</el-col>-->
                                                            <!--<el-col :span="9" style="text-align: left">-->
                                                                <!--<el-form-item  :prop="'tableData2.' + scope.$index + '.count2'" :rules='discounts.count2' >-->
                                                                    <!--<el-input-->
                                                                            <!--onkeyup="this.value=this.value.replace(/[^\d]/g,'');"-->
                                                                            <!--size="mini"-->
                                                                            <!--v-model="scope.row.count2"-->
                                                                            <!--style="width: 150px"/>-->
                                                                <!--</el-form-item>-->
                                                            <!--</el-col>-->
                                                        <!--</el-row>-->
                                                    <!--</template>-->
                                                <!--</el-table-column>-->
                                                <!--<el-table-column-->
                                                        <!--label="价格"-->
                                                        <!--align="center"-->
                                                        <!--width="230">-->
                                                    <!--<template slot-scope="scope">-->
                                                        <!--<el-row>-->
                                                            <!--<el-col :span="24" style="text-align: left">-->
                                                                <!--<el-form-item  :prop="'tableData2.' + scope.$index + '.price'" :rules='discounts.price'>-->
                                                                    <!--<el-input-->
                                                                            <!--onkeyup="this.value=this.value.replace(/[^\d]/g,'');"-->
                                                                            <!--size="mini"-->
                                                                            <!--v-model="scope.row.price"-->
                                                                            <!--style="width: 150px"/>-->
                                                                    <!--<span>TWD</span>-->
                                                                <!--</el-form-item>-->
                                                            <!--</el-col>-->
                                                        <!--</el-row>-->
                                                    <!--</template>-->
                                                <!--</el-table-column>-->
                                                <!--<el-table-column prop="handel" label="操作" align="center" width="150">-->
                                                    <!--<template slot-scope="scope">-->
                                                        <!--<el-button type="text" size="mini" @click="deleteRow(scope.$index)">移除-->
                                                        <!--</el-button>-->
                                                    <!--</template>-->
                                                <!--</el-table-column>-->
                                            <!--</el-table>-->
                                        <!--</el-form>-->
                                    <!--</el-col>-->
                                    <!--&lt;!&ndash;为空则显示在右边&ndash;&gt;-->
                                    <!--<el-col :span="2" v-show="bzxx.tableData2.length<=0">-->
                                        <!--<el-button type="text" size="mini" @click="add">新增区间</el-button>-->
                                    <!--</el-col>-->
                                <!--</el-row>-->
                                <!--&lt;!&ndash;不为空则显示在表格下面&ndash;&gt;-->
                                <!--<el-row v-show="bzxx.tableData2.length >0">-->
                                    <!--<el-col :span="3" style="text-align: right">-->
                                        <!--<el-button type="text" size="mini" @click="add">新增区间</el-button>-->
                                    <!--</el-col>-->
                                <!--</el-row>-->

                            <!--</div>-->
                        <!--</div>-->
                    <!--</el-main>-->
                <!--</el-container>-->
            <!--</div>-->
            <!--变种信息2_测试-->
            <div style="background-color: white;margin-top: 15px" class="t_plane self_el_item_form">
                <el-container>
                    <!-- 头部 -->
                    <el-header style="color: #A2A2A2;padding-top: 20px;height: 30px"><strong>变种信息</strong></el-header>
                    <!-- 分割线 -->
                    <el-divider margin="8px,0"></el-divider>
                    <el-main style="width: 100%">
                        <el-row>
                            <el-col :span="2">
                                <span style="margin-right: 15px">变种主题:</span>
                            </el-col>
                            <!-- =2,不能添加-->
                            <div class="iconStyle" v-if="bzxx.testDynamicAttrList.length >= 2">
                                <el-col :span="2" v-for="(item, index) in bzxx.AttrList" style="cursor: no-drop;color: #d0d3d6;">
                                    <i class="el-icon-circle-plus-outline"></i>
                                    <span>{{item.name}}</span>
                                </el-col>
                            </div>
                            <!-- <2,可以点击添加-->
                            <div class="iconStyle2" v-if="bzxx.testDynamicAttrList.length<2">
                                <el-col :span="2" v-for="(item, index) in bzxx.AttrList" style="color:  #4934b2;">
                                    <i class="el-icon-circle-plus-outline" @click="addColorAndSize_2(item.name,index)"></i>
                                    <span>{{item.name}}</span>
                                </el-col>
                            </div>
                            <!-- <2 可以点击添加-->
                            <el-col :span="2" v-show="bzxx.testDynamicAttrList.length < 2">
                                <el-button type="primary" style="margin-left: 15px" size="mini" @click="addAttr">添加自定义属性</el-button>
                            </el-col>
                            <!-- >=2 ,不能点击添加-->
                            <el-col :span="2" v-show="bzxx.testDynamicAttrList.length >= 2">
                                <el-button type="primary" style="margin-left: 15px" size="mini" @click="addAttr" disabled>添加自定义属性</el-button>
                            </el-col>
                        </el-row>
                        <div style="background-color: white;margin-top: 15px;width: 100%">
                            <el-container style="border: 1px solid #DCDFE6;margin-bottom: 15px" v-for="(testDynamic, testDynamicIndex) in bzxx.testDynamicAttrList">
                                <!-- 头部 -->
                                <el-header style="background-color: #F7F7F7;color: #A2A2A2;padding-top: 20px">
                                    <!--1:采集的属性名,2:Color,3:SIZE-->
                                    <el-col :span="5" v-if="testDynamic.attrType=='1'" >
                                        <strong>变种主题{{testDynamicIndex+1}}:{{testDynamic.attrName}}</strong>
                                    </el-col>
                                    <el-col :span="5" v-else-if="testDynamic.attrType=='2'">
                                        <strong>变种主题{{testDynamicIndex+1}}:Color</strong>
                                    </el-col>
                                    <el-col :span="5" v-else-if="testDynamic.attrType=='3'">
                                        <strong>变种主题{{testDynamicIndex+1}}:Size</strong>
                                    </el-col>
                                    <el-col :span="19" style="text-align: right">
                                        <span><el-link type="primary" @click="removeAttr_2(testDynamicIndex)">移除</el-link></span>
                                    </el-col>
                                </el-header>
                                <el-main style="width: 100%">
                                    <div>
                                        <!--颜色属性值,attrType为2才显示颜色列表-->
                                        <el-row style="margin-left: 4.16667%;" v-show="testDynamic.attrType=='2'">
                                            <el-col :span="3" v-for="(item, index) in testDynamic.attrVal">
                                                <el-checkbox v-model="item.checked" @change="checkAttr($event,testDynamicIndex,index)">
                                                    <span class="spanStyle" :style="{background:item.colorCode,color:item.fontColor}">{{item.attrValName}}</span>
                                                </el-checkbox>
                                            </el-col>
                                        </el-row>
                                        <!--Size属性值,attrType为3才显示Size列表-->
                                        <el-row style="margin-left: 4.16667%;" v-show="testDynamic.attrType=='3'">
                                            <el-col :span="3" v-for="(item, index) in testDynamic.attrVal">
                                                <el-checkbox v-model="item.checked" @change="checkAttr($event,testDynamicIndex,index)">
                                                    <span>{{item.attrValName}}</span>
                                                </el-checkbox>
                                            </el-col>
                                        </el-row>
                                        <!--采集或者自己添加的属性值-->
                                        <el-row style="margin-top: 15px">
                                            <el-col :span="4.5" v-for="(attrValItem,attrValIndex) in testDynamic.attrVal"  style="margin-left: 4.16667%" v-show="attrValItem.colorOrSize=='1'">
                                                <!--未编辑-->
                                                <el-row v-show="attrValItem.edit==false">
                                                    <!--tableDataColumn-->
                                                    <!--@change="bzxxChecked($event,testDynamicIndex,attrValIndex)"-->
                                                    <el-checkbox v-model="attrValItem.checked" @change="checkAttr($event,testDynamicIndex,attrValIndex)">
                                                        <span>{{attrValItem.attrValName}}</span>
                                                    </el-checkbox>
                                                    <el-tooltip  effect="light" content="修改" placement="bottom-start" >
                                                        <i class="el-icon-edit" style="margin-left: 5px" @click="iconEdit(testDynamicIndex,attrValIndex)"></i>
                                                    </el-tooltip>
                                                </el-row>
                                                <!--正在编辑-->
                                                <el-row v-show="attrValItem.edit!=false">
                                                    <el-input type="text" v-model="attrValItem.backupName" placeholder="请输入内容" size="small" style="width: 110px"  maxlength="20" show-word-limit></el-input>
                                                    <el-tooltip  effect="light" content="保存" placement="bottom-start" >
                                                        <i class="el-icon-document-checked" style="margin-left: 5px" @click="iconSave(testDynamicIndex,attrValIndex)"></i>
                                                    </el-tooltip>
                                                    <el-tooltip effect="light" content="取消" placement="bottom-start">
                                                        <i class="el-icon-circle-close" style="margin-left: 5px" @click="iconCancel(testDynamicIndex,attrValIndex)"></i>
                                                    </el-tooltip>
                                                </el-row>
                                            </el-col>
                                        </el-row>
                                        <!--添加属性值-->
                                        <el-row class="uploadBzxx">
                                            <el-input type="text" v-model="testDynamic.attrValInputName" placeholder="请输入内容" style="width: 300px" size="small"  maxlength="20" show-word-limit></el-input>
                                            <el-button type="primary" style="margin-left: 15px" size="small" @click="addValName_2(testDynamicIndex)">添加</el-button>
                                        </el-row>
                                        <!--为checked=true的属性值添加一个上传组件-->
                                        <el-row class="uploadBzxx">
                                            <el-col :span="3"  v-for="(item, index) in testDynamic.attrVal" v-if="item.checked==true && testDynamicIndex==0">
                                                <el-row style="border: 1px solid #e8e8e8;width: 95px;">
                                                    <div style="font-size: 12px" class="divOverflow">{{item.attrValName}}</div>
                                                </el-row>
                                                <el-upload
                                                        class="upload-demo"
                                                        drag
                                                        action="#"
                                                        multiple
                                                        v-show="item.picUrl==''"
                                                        :http-request="(value)=> bzxxUpload(item, value)"
                                                        :show-file-list="false"
                                                        :on-success="(value)=> handleBannerSuccess(testDynamic,index, value)">
                                                    <el-row>
                                                        <i class="el-icon-plus"></i>
                                                    </el-row>
                                                    <span>添加图片</span>
                                                </el-upload>
                                                <el-row v-show="item.picUrl!=''" class="bzxxDeleIcon">
                                                    <el-col :span="13">
                                                        <img :src="item.picUrl" style="width: 95px;height: 100px;">
                                                    </el-col>
                                                    <el-col :span="10" style="text-align: left;height: 30px">
                                                        <i class="el-icon-error" style="cursor: pointer" @click="bzxxDeletePic(testDynamicIndex,index)"></i>
                                                    </el-col>
                                                </el-row>
                                            </el-col>
                                        </el-row>
                                    </div>
                                </el-main>
                            </el-container>
                            <!--主题表格这里结束-->
                            <!--<el-row style="color: #8a8a8a">-->
                            <!--只有选择了折扣活动,填写限购,折扣才会生效,限购为"0",表示不限购-->
                            <!--</el-row>-->
                            <!--表格-->
                            <div style="margin-top: 20px">
                                <el-table
                                        :data="bzxx.tableData"
                                        style="width: 100%" v-show="bzxx.tableData.length>0">
                                    <!--动态展示列是否显示-->
                                    <el-table-column
                                            width="100" v-for="(item,index) in bzxx.attrNameList"
                                            :label="item"
                                            :prop='"column_"+index+""'>
                                    </el-table-column>
                                    <el-table-column
                                            prop="name"
                                            align="center"
                                            width="150">
                                        <template slot="header" slot-scope="scope">
                                            <el-row>SKU</el-row>
                                            <el-row>
                                                <el-button type="text" @click="AutomaticGeneration">(自动生成)</el-button>
                                            </el-row>
                                        </template>
                                        <template slot-scope="scope">
                                            <el-input
                                                    size="mini"
                                                    v-model="scope.row.skuno"
                                                    style="width: 100px"/>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            prop="name"
                                            align="center"
                                            width="100">
                                        <template slot="header" slot-scope="scope">
                                            <el-row>价格</el-row>
                                            <el-row>
                                                <el-button type="text" @click="updatePriceDig">(修改)</el-button>
                                            </el-row>
                                        </template>
                                        <template slot-scope="scope">
                                            <el-input
                                                    onkeyup="this.value=this.value.replace(/[^\d.]/g, '').replace(/^\.{1,}/g,'').replace(/^0{2,}/g,'').match(/^\d*(\.?\d{0,2})/g);"
                                                    size="mini"
                                                    v-model="scope.row.price"
                                                    style="width: 70px"/>
                                        </template>
                                    </el-table-column>
                                    <el-table-column>
                                        <template slot="header" slot-scope="scope">
                                            <el-row>
                                                <el-col :span="12">
                                                    <span>折扣活动</span>
                                                    <span style="color: #029ef3">请选择</span>
                                                </el-col>
                                                <el-col :span="12" style="text-align: right">
                                                    <span>限购</span>
                                                    <el-input
                                                            size="mini"
                                                            v-model="bzxx.input"
                                                            style="width: 100px"/>
                                                </el-col>
                                            </el-row>
                                        </template>
                                        <el-table-column
                                                prop="province"
                                                width="600">
                                            <template slot="header" slot-scope="scope">
                                                <el-row>
                                                    <el-col :span="12">
                                                        <div style="text-align: left;margin-left: 60px;">
                                                            <span>促销价</span>
                                                            <span style="color: #029ef3">(批量)</span>
                                                        </div>
                                                    </el-col>
                                                    <el-col :span="12">
                                                        <div style="text-align: right;margin-right: 60px;">
                                                            <span>折扣</span>
                                                            <span style="color: #029ef3">(批量)</span>
                                                        </div>
                                                    </el-col>
                                                </el-row>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-row>
                                                    <el-col :span="3">
                                                        <el-switch
                                                                v-model="scope.row.switchValue"
                                                                active-color="#13ce66"
                                                                inactive-color="#CCCCCC">
                                                        </el-switch>
                                                    </el-col>
                                                    <el-col :span="7">
                                                        <el-input
                                                                size="mini"
                                                                v-model="scope.row.promPrice"
                                                                style="width: 150px"/>
                                                    </el-col>
                                                    <el-col :span="4" style="text-align: center">
                                                        <span>或</span>
                                                    </el-col>
                                                    <el-col :span="10" style="text-align: right">
                                                        <el-input
                                                                size="mini"
                                                                v-model="scope.row.discount"
                                                                style="width: 150px"/>
                                                        <span>%OFF(0折)</span>
                                                    </el-col>
                                                </el-row>
                                            </template>
                                        </el-table-column>
                                    </el-table-column>
                                    <el-table-column
                                            prop="name"
                                            align="center">
                                        <template slot="header" slot-scope="scope">
                                            <el-row>库存</el-row>
                                            <el-row>
                                                <el-button type="text" @click="updateInventDig">(修改)</el-button>
                                            </el-row>
                                        </template>
                                        <template slot-scope="scope">
                                            <el-input
                                                    onkeyup="this.value=this.value.replace(/[^\d]/g, '').replace(/^0{2,}/g,'');"
                                                    size="mini"
                                                    v-model="scope.row.invent"
                                                    style="width: 100px"/>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                            <!--多件优惠-->
                            <div style="margin-top: 15px">
                                <el-row>
                                    <el-col :span="2" style="text-align: right">
                                        <span style="font-size: 12px">多件优惠:</span>
                                    </el-col>
                                    <el-col :span="20" v-show="bzxx.tableData2.length >0">
                                        <el-form  :model="bzxx" ref="bzxx">
                                            <el-table
                                                    border
                                                    :data="bzxx.tableData2"
                                                    style="width: 100%"
                                                    :header-cell-style="{background:'#eef1f6',color:'#595a5a'}">
                                                <el-table-column
                                                        label=""
                                                        width="180"
                                                        align="center">
                                                    <template slot-scope="scope">
                                                        <el-form-item  >
                                                            <span>{{scope.row.sort+(scope.$index+1)}}</span>
                                                        </el-form-item>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        label="购买数量"
                                                        align="center">
                                                    <template slot-scope="scope">
                                                        <el-row>
                                                            <el-col :span="9" style="text-align: left">
                                                                <el-form-item  :prop="'tableData2.' + scope.$index + '.count1'" :rules='discounts.count1'>
                                                                    <el-input
                                                                            onkeyup="this.value=this.value.replace(/[^\d]/g,'');"
                                                                            size="mini"
                                                                            v-model="scope.row.count1"
                                                                            style="width: 150px"/>
                                                                </el-form-item>
                                                            </el-col>
                                                            <el-col :span="1" class="line">
                                                                <el-form-item>-</el-form-item>
                                                            </el-col>
                                                            <el-col :span="9" style="text-align: left">
                                                                <el-form-item  :prop="'tableData2.' + scope.$index + '.count2'" :rules='discounts.count2' >
                                                                    <el-input
                                                                            onkeyup="this.value=this.value.replace(/[^\d]/g,'');"
                                                                            size="mini"
                                                                            v-model="scope.row.count2"
                                                                            style="width: 150px"/>
                                                                </el-form-item>
                                                            </el-col>
                                                        </el-row>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        label="价格"
                                                        align="center"
                                                        width="230">
                                                    <template slot-scope="scope">
                                                        <el-row>
                                                            <el-col :span="24" style="text-align: left">
                                                                <el-form-item  :prop="'tableData2.' + scope.$index + '.price'" :rules='discounts.price'>
                                                                    <el-input
                                                                            onkeyup="this.value=this.value.replace(/[^\d]/g,'');"
                                                                            size="mini"
                                                                            v-model="scope.row.price"
                                                                            style="width: 150px"/>
                                                                    <span>TWD</span>
                                                                </el-form-item>
                                                            </el-col>
                                                        </el-row>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column prop="handel" label="操作" align="center" width="150">
                                                    <template slot-scope="scope">
                                                        <el-button type="text" size="mini" @click="deleteRow(scope.$index)">移除
                                                        </el-button>
                                                    </template>
                                                </el-table-column>
                                            </el-table>
                                        </el-form>
                                    </el-col>
                                    <!--为空则显示在右边-->
                                    <el-col :span="2" v-show="bzxx.tableData2.length<=0">
                                        <el-button type="text" size="mini" @click="add">新增区间</el-button>
                                    </el-col>
                                </el-row>
                                <!--不为空则显示在表格下面-->
                                <el-row v-show="bzxx.tableData2.length >0">
                                    <el-col :span="3" style="text-align: right">
                                        <el-button type="text" size="mini" @click="add">新增区间</el-button>
                                    </el-col>
                                </el-row>

                            </div>
                        </div>
                    </el-main>
                </el-container>
            </div>
            <!--包装与运输-->
            <div style="background-color: white;margin-top: 15px" class="t_plane self_el_item_form">
                <el-container>
                    <!-- 头部 -->
                    <el-header style="color: #A2A2A2;padding-top: 20px;height: 30px"><strong>包装与运输</strong></el-header>
                    <!-- 分割线 -->
                    <el-divider margin="8px,0"></el-divider>
                    <el-main style="width: 100%">
                        <div>
                            <el-form ref="BzyysFormLabelAlign" label-width="80px" :model="bzyys.formLabelAlign" :rules="rules">
                                <el-form-item label="重量:" prop="packWeight">
                                    <el-input
                                            onkeyup="this.value=this.value.replace(/[^\d.]/g, '').replace(/^\.{1,}/g,'').replace(/^0{2,}/g,'').match(/^\d*(\.?\d{0,2})/g);"
                                            v-model="bzyys.formLabelAlign.packWeight"
                                            style="width: 200px"
                                            size="small">
                                        <template slot="append">KG</template>
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="尺寸规格:">
                                    <el-input
                                            @input="limitNumber($event,'long')"
                                            onkeyup="this.value=this.value.replace(/[^\d]/g, '').replace(/^0{1,}/g,'');"
                                            v-model="bzyys.formLabelAlign.packLong"
                                            style="width: 200px"
                                            size="small">
                                        <template slot="append">CM</template>
                                    </el-input>
                                    <el-input
                                            @input="limitNumber($event,'wide')"
                                            onkeyup="this.value=this.value.replace(/[^\d]/g, '').replace(/^0{1,}/g,'');"
                                            v-model="bzyys.formLabelAlign.packWide"
                                            style="width: 200px;margin-left: 20px"
                                            size="small">
                                        <template slot="append">CM</template>
                                    </el-input>
                                    <el-input
                                            @input="limitNumber($event,'high')"
                                            onkeyup="this.value=this.value.replace(/[^\d]/g, '').replace(/^0{1,}/g,'');"
                                            v-model="bzyys.formLabelAlign.packHigh"
                                            style="width: 200px;margin-left: 20px"
                                            size="small">
                                        <template slot="append">CM</template>
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="是否预估">
                                    <el-radio v-model="bzyys.formLabelAlign.purch" label="0">否</el-radio>
                                    <el-radio v-model="bzyys.formLabelAlign.purch" label="1">是</el-radio>
                                </el-form-item>
                                <el-form-item label="物流设置">
                                    <el-table
                                            border
                                            :data="bzyys.wlszTable"
                                            style="width: 100%"
                                            :header-cell-style="{background:'#eef1f6',color:'#595a5a'}">
                                        <el-table-column
                                                prop="name"
                                                label="物流方式(勾选开启)"
                                                width="500">
                                            <template slot-scope="scope">
                                                <table style="width: 105%">
                                                    <tr>
                                                        <td style="border-bottom: 1px solid #A2A2A2;">
                                                            <el-checkbox label="虾皮店配-全家"></el-checkbox>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style="border-bottom: 1px solid #A2A2A2;">
                                                            <el-checkbox label="虾皮店配-莱尔富(超值)"></el-checkbox>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style="border-bottom: 1px solid #A2A2A2;">
                                                            <el-checkbox label="虾皮宅配"></el-checkbox>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style="border-bottom: none;">
                                                            <el-checkbox label="虾皮店配-711"></el-checkbox>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="address"
                                                label="运费设置">
                                            <template slot-scope="scope">
                                                <table style="width: 105%">
                                                    <tr>
                                                        <td style="border-bottom: 1px solid #A2A2A2;">
                                                            <el-col :span="10">
                                                                <span>运费:依据重量自动计算</span>
                                                            </el-col>
                                                            <el-col :span="10" style="text-align: right">
                                                                <el-checkbox  label="免邮"></el-checkbox>
                                                            </el-col>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style="border-bottom: 1px solid #A2A2A2;">
                                                            <el-col :span="10">
                                                                <span>运费:依据重量自动计算</span>
                                                            </el-col>
                                                            <el-col :span="10" style="text-align: right">
                                                                <el-checkbox  label="免邮"></el-checkbox>
                                                            </el-col>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style="border-bottom: 1px solid #A2A2A2;">
                                                            <el-col :span="10">
                                                                <span>运费:依据重量自动计算</span>
                                                            </el-col>
                                                            <el-col :span="10" style="text-align: right">
                                                                <el-checkbox  label="免邮"></el-checkbox>
                                                            </el-col>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style="border-bottom: none;">
                                                            <el-col :span="10">
                                                                <span>运费:依据重量自动计算</span>
                                                            </el-col>
                                                            <el-col :span="10" style="text-align: right">
                                                                <el-checkbox  label="免邮"></el-checkbox>
                                                            </el-col>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </el-form-item>
                            </el-form>
                        </div>
                    </el-main>
                </el-container>
            </div>
            <!--虾皮平台类目-->
            <el-dialog :close-on-click-modal="false"  
                    title="虾皮平台类目"
                    :visible.sync="shopeeDialogVisible"
                    width="50%"
                    center>
                <div style="height: 250px;">
                    <span>搜索</span>
                    <el-cascader
                            ref="cascaderAddr"
                            v-model="platType"
                            placeholder="试试搜索"
                            :options="shopeeOptions"
                            filterable
                            style="width: 300px"></el-cascader>
                </div>
                <span slot="footer" class="dialog-footer">
                <el-button @click="shopeeDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="shopeeDialogSubmit">确 定</el-button>
            </span>
            </el-dialog>
            <!--添加自定义属性弹框-->
            <el-dialog :close-on-click-modal="false"  
                    title="自定义属性"
                    :visible.sync="bzxx.attrDig"
                    width="30%"
                    >
                <el-row style="margin-top: 15px">
                    <el-col :span="6" style="margin-top: 5px;margin-left: 10px">
                        自定义属性名称
                    </el-col>
                    <el-col :span="10">
                        <el-input v-model="bzxx.attrInputName" placeholder="请输入内容" size="small" :autofocus="true"></el-input>
                    </el-col>
                </el-row>
                <span slot="footer" class="dialog-footer">
                <el-button @click="bzxx.attrDig = false" size="small">取 消</el-button>
                <el-button type="primary" @click="addAttrSubmit" size="small">确 定</el-button>
            </span>
            </el-dialog>
            <!--修改价钱弹框-->
            <el-dialog :close-on-click-modal="false"  
                    title="修改价格"
                    :visible.sync="bzxx.updatePriceDig"
                    width="30%"
                    
                    @close="cancelPrice">
                <el-row style="margin-top: 15px;margin-left: 30px">
                    <el-radio-group v-model="bzxx.priceRadio" @change="priceRadioChange">
                        <el-radio :label="0">
                            <!--正则校验价格-->
                            <el-input onkeyup="this.value=this.value.replace(/[^\d.]/g, '').replace(/^\.{1,}/g,'').replace(/^0{2,}/g,'').match(/^\d*(\.?\d{0,2})/g);"  ref="priceInput_1" :disabled="bzxx.priceRadioDisabled_1" style="width: 100px;margin-left: 20px" v-model="bzxx.priceInput_1" placeholder="请输入内容" size="mini"></el-input>
                            <span>(直接修改价格)</span>
                        </el-radio>
                        <div style="margin-bottom: 20px"></div>
                        <el-radio :label="1">
                            <span style="margin-left: 7px">按</span>
                            <el-select clearable  :disabled="bzxx.priceRadioDisabled_2" v-model="bzxx.priceTypeValue" placeholder="请选择" size="mini" style="width: 100px">
                                <el-option
                                        v-for="item in bzxx.priceType"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                            <span style="margin-right: 12px">增加</span>
                            <!--正则校验价格-->
                            <el-input onkeyup="this.value=this.value.replace(/[^\d.]/g, '').replace(/^\.{1,}/g,'').replace(/^0{2,}/g,'').match(/^\d*(\.?\d{0,2})/g);"  style="width: 100px;" :disabled="bzxx.priceRadioDisabled_2" :precision="2" v-model="bzxx.priceInput_2" placeholder="请输入内容" size="mini"></el-input>
                            <span v-show="bzxx.priceTypeValue==1">%</span>
                        </el-radio>
                    </el-radio-group>
                </el-row>
                <span slot="footer" class="dialog-footer">
                <el-button @click="cancelPrice" size="small">取 消</el-button>
                <el-button type="primary" @click="sumbitPrice" size="small">确 定</el-button>
            </span>
            </el-dialog>
            <!--修改库存弹框-->
            <el-dialog :close-on-click-modal="false"  
                    title="修改库存"
                    :visible.sync="bzxx.updateInventDig"
                    width="30%"
                    
                    @close="cancelPrice">
                <el-row style="margin-top: 15px;margin-left: 30px">
                    <el-radio-group v-model="bzxx.inventRadio" @change="inventRadioChange">
                        <el-radio :label="0">
                            <!--正则校验价格-->
                            <el-input ref="inventInput_1" onkeyup="this.value=this.value.replace(/[^\d]/g, '').replace(/^0{2,}/g,'');"  :disabled="bzxx.inventRadioDisabled_1" style="width: 100px" v-model="bzxx.inventInput_1" placeholder="请输入内容" size="mini"></el-input>
                            <span>(直接修改库存量)</span>
                        </el-radio>
                        <div style="margin-bottom: 20px"></div>
                        <el-radio :label="1">
                            <span>按原有库存量 增加</span>
                            <!--正则校验价格-->
                            <el-input onkeyup="this.value=this.value.replace(/[^\d\-]/g, '').replace(/^0{0,}/g,'').replace(/^\-{2}/g,'').match(/^(\-?)\d*/g);"  style="width: 100px;" :disabled="bzxx.inventRadioDisabled_2"  v-model="bzxx.inventInput_2" placeholder="请输入内容" size="mini"></el-input>
                        </el-radio>
                    </el-radio-group>
                    <el-row>
                        <span>提示:如果减少,可输入负数</span>
                    </el-row>
                </el-row>
                <span slot="footer" class="dialog-footer">
                <el-button @click="cancelInvent" size="small">取 消</el-button>
                <el-button type="primary" @click="sumbitInvent" size="small">确 定</el-button>
            </span>
            </el-dialog>

            <ul id="LoutiNav" style="position: fixed;display: block;">
                <li><span>基本信息</span></li>
                <li><span>xx信息</span></li>
                <li><span>产品信息</span></li>
                <li><span>图片信息</span></li>
                <li><span>变种信息</span></li>
                <li><span>包装与运输</span></li>
            </ul>
        </div>
    </div>
    <!--基本信息-->
</template>

<script>

    import ElRow from "element-ui/packages/row/src/row";
    import Breadcrumb from '@/components/common/Breadcrumb'
    //拖动图片插件
    import draggable from 'vuedraggable';
    import {getShopByPlatCode,publicUploadImg,getPicListBypId} from '@/api/product/common';
    import {getShopee,getShopeeEdit,bzxxPicUpload,getBzxxColor,getBzxxSize,saveEdit} from '@/api/product/shopee/shopee';
    import {getList} from '@/api/product/shopee/shopeeBrand.js';
    import TreeSelect from '@/components/common/treeSelect';
    import {loadDataMap} from '@/api/tree/tree'
    import {getPlatTypeTree,getPlatTypeName,getPlatTypeNames} from '@/api/plat/platType';
    import {getListByAttrId,export1} from '@/api/plat/val';
    import {getListByCatId,getPublicAttr,getSPlatAttrId} from '@/api/plat/attr';
    import { downLoadZip } from "@/utils/zipdownload";
    import {calcDescartes} from '@/utils/jn';

    export default {
        //注册组件
        components: {
            ElRow,
            draggable,
            TreeSelect,
            Breadcrumb
        },
        name: "CollectionBox",
        data() {
            return {
                loading:false,
                jbxxForm: {
                    shopName:null,
                    brand:null ,
                    cpfl:null,
                },
                xxForm: {
                    fl: '',
                    urls: [],//动态添加的URL
                    defaultUrl: null, //默认展示的第一个URL
                    typeNo:null,
                },
                cpForm:{
                    //售卖类型
                    sellType:'01',
                    parentSku:null,
                    proTitle:null,
                    detail:null,
                },
                claimList:[],
                rules: {
                    account: [
                        {required: true, message: '请选择店铺名称', trigger: 'blur'},
                    ],
                    cpfl: [
                        {required: true, message: '请选择产品分类', trigger: 'blur'},
                    ],
                    brand: [
                        {required: true, message: '品牌分类不能为空', trigger: 'blur'},
                    ],
                    //产品表单校验
                    proTitle: [
                        {required: true, message: '产品标题不能为空', trigger: 'blur'},
                    ],
                    detail: [
                        {required: true, message: '产品描述不能为空', trigger: 'blur'},
                    ],
                    //包装与运输的表单校验
                    packWeight: [
                        {required: true, message: '重量不能为空', trigger: 'blur'},
                    ],
                },
                //新增优惠验证
                discounts: {
                    count1: [
                        {required: true, message: '最小购买数量不能为空', trigger: 'blur'},
                    ],
                    count2: [
                        {required: true, message: '最大购买数量不能为空', trigger: 'blur'},
                    ],
                    price: [
                        {required: true, message: '价格不能为空', trigger: 'blur'},
                    ],
                },
                // 单选
                radio: '1',
                //产品图片
                fileList: [{
                    name: 'food.jpeg',
                    url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
                }, {
                    name: 'food2.jpeg',
                    url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
                }],
                //用于统计选择的图片数量
                count: 0,
                picList: [],//普通照片
                sizePicList:[], //尺寸照片
                // 保存图片的ID
                picID: [],
                //变种信息属性
                bzxx: {
                    //添加自定义属性,默认有两个 color size,如果有其他的属性,这两个不能点击
                    AttrList:[
                        {
                            name:'Color',
                        },
                        {
                            name:'Size',
                        }
                    ],
                    attrDig:false, //添加自动以属性框
                    colorList:[],//color的颜色集合
                    sizeList:[], //size的大小集合
                    attrInputName:null,   //自定义属性名
                    //测试变种主题动态CRUD的数据
                    testDynamicAttrList:[
                        {
                            attrName:'颜色',
                            attrVal:[
                                {
                                    attrValName:'红色',
                                    edit:false,
                                    backupName:'',
                                    checked:false,
                                    colorOrSize:'1', //判断是不是属于原始的颜色组
                                    picUrl:'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1599302071924&di=7535d97808218240ed4d369fd84a6ace&imgtype=0&src=http%3A%2F%2Fn.sinaimg.cn%2Fsinacn19%2F722%2Fw870h652%2F20180810%2Fa358-hhnunsq9933127.jpg',

                                },
                                {
                                    attrValName:'黑色',
                                    edit:false,
                                    backupName:'',
                                    checked:false,
                                    colorOrSize:'1', //判断是不是属于原始的颜色组
                                    picUrl:'',
                                }
                            ],
                            attrValInputName:'',
                            attrType:'1', //判断是不是属于原始的颜色组,
                            view:true, //是否显示列
                            DynamicAttrName:'',//动态的列展示数据属性
                        },
                        {
                            attrName:'身高',
                            attrVal:[
                                {
                                    attrValName:'150CM',
                                    edit:false,
                                    backupName:'',
                                    checked:false,
                                    colorOrSize:'1', //判断是不是属于原始的颜色组
                                    picUrl:'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1599302071924&di=7535d97808218240ed4d369fd84a6ace&imgtype=0&src=http%3A%2F%2Fn.sinaimg.cn%2Fsinacn19%2F722%2Fw870h652%2F20180810%2Fa358-hhnunsq9933127.jpg',
                                },
                                {
                                    attrValName:'200CM',
                                    edit:false,
                                    backupName:'',
                                    checked:false,
                                    colorOrSize:'1', //判断是不是属于原始的颜色组
                                    picUrl:'',
                                }
                            ],
                            attrValInputName:'',
                            attrType:'1', //判断是不是属于原始的颜色组
                            view:false, //是否显示列
                            DynamicAttrName:'',//动态的列展示数据属性
                        },
                    ],

                    color: '',
                    size: '',
                    inputValName: '',
                    switchValue: '',
                    tableData: [
                        {
                            0: "黑色",
                            1: "",
                            discount: "",
                            invent: "",
                            price: "20.00",
                            promPrice: "",
                            sku: "",
                            switchValue: false,
                        }
                    ],
                    attrNameList:[], //动态列名
                    colorId:'', //固定颜色ID
                    sizeId:'',//固定SizeID
                    tableData2:[],//优惠集合
                    updatePriceDig:false, //修改价格弹框
                    priceType: [{
                        value:0,
                        label: '金额'
                    }, {
                        value: 1,
                        label: '百分比'
                    }],
                    priceTypeValue:0, //默认选择金额为首选
                    priceRadio:0, //修改价钱radio的值
                    priceRadioDisabled_1:false,//显示直接修改价格
                    priceRadioDisabled_2:true,//禁止第二个选择
                    priceInput_1:null,//第一个价钱输入框的值
                    priceInput_2:null,//第二个价钱输入框的值
                    updateInventDig:false, //修改库存弹框
                    inventInput_1:null,//第一个库存输入框的值
                    inventInput_2:null,//第二个库存输入框的值
                    inventRadio:0, //修改库存radio的值
                    inventRadioDisabled_1:false,//显示直接修改库存
                    inventRadioDisabled_2:true,//禁止第二个选择
                },
                bzyys: {
                    labelPosition: 'right',
                    formLabelAlign: {
                        packWeight: null,
                        packLong: null,
                        packWide: null,
                        packHigh: null,
                        purch: '0',
                    },
                    tableData: [{
                        date: '2016-05-02',
                        name: '王小虎',
                        address: '上海市普陀区金沙江路 1518 弄'
                    }, {
                        date: '2016-05-04',
                        name: '王小虎',
                        address: '上海市普陀区金沙江路 1517 弄'
                    }, {
                        date: '2016-05-01',
                        name: '王小虎',
                        address: '上海市普陀区金沙江路 1519 弄'
                    }, {
                        date: '2016-05-03',
                        name: '王小虎',
                        address: '上海市普陀区金沙江路 1516 弄'
                    }],
                    wlszTable: [{
                        date: '2016-05-02',
                        name: '王小虎',
                        address: '上海市普陀区金沙江路 1518 弄'
                    }],
                    checkList: ['选中且禁用','复选框 A']
                },
                //字典
                brandOption:[],//品牌
                materialOption:[],//材质
                styleOption:[],//样式
                style2Option:[],//款式
                //下拉树
                treeSelect: {
                    value: 'id',
                    label: 'name',
                    children: 'children',
                },
                //树形数据
                dataList:[],
                shopeeDialogVisible:false, //虾皮类目弹框
                //虾皮树
                shopeeOptions: [],
                platType:null,//类目值
                attrId:null,//类目的最后一级ID,用于查出所有的属性List
                catList:[], //类目的最后一级的数据集合
                selectValue:[],//产品属性动态select值
                selectValueList:[], //产品的下拉框属性集合
                cascaderName:null, //级联全路径名字
                catId:null,//用于选择类目时,动态展示产品属性
                sShopeeValList:[],//产品属性list
                brandVO:[],//独立出来的品牌
                picType:null, //图片类型
                uploadDis:true,
            };
        },
        watch: {

        },
        created() {
            let that = this;
            //获取当前用户
            var userName = this.$store.state.user.name;
            var params  ='05';
            //获取店铺集合
            getShopByPlatCode(params).then((res) => {
                that.claimList=res.data;
            })
            that.loadData(that);
            //品牌
            that.getDicts("shopee_brand").then(response => {
                // that.brandOption = response.data;
            });
            // 获取本平台树
            loadDataMap().then((res) => {
                that.dataList=that.optionData(res.data);
                setTimeout(function () {
                    that.$refs.childSelTree.initHandle();
                },100);
            })
            that.getPicList();
            that.getSizePic();
            that.deleteColorOrSize()
            that.getPublicAttr();
            that.getSPlatAttrId();

        },
        methods: {
            //加载编辑数据
            loadData(that){
                getShopeeEdit(this.$route.query.pId).then((res) => {
                    that.bzxx.testDynamicAttrList=res.data.attrList;
                    that.bzxx.attrNameList =res.data.columnNameList;
                    //如果有相同的属性则删除
                    for (var i=0; i<res.data.columnNameList.length;i++){
                        for (var j=0; j<that.bzxx.AttrList.length;j++){
                            if (that.bzxx.AttrList[j].name == res.data.columnNameList[i]){
                                that.bzxx.AttrList.splice(j,1);
                            }
                        }
                    }
                    that.bzxx.tableData = res.data.tableData;
                    //店铺名
                    that.jbxxForm.shopName=res.data.shopId
                    //本平台分类
                    if (res.data.typeNo!=null){
                        that.xxForm.typeNo=parseInt(res.data.typeNo);
                    }
                    //URL数组
                    let urls = res.data.urls;
                    if (urls!=null && urls!=''){
                        //默认URL数组
                        that.xxForm.defaultUrl=res.data.urls[0];
                        //删除掉默认的数组
                        urls.splice(0, 1);
                        //循环剩下的数组
                        that.xxForm.urls = urls;
                    }
                    //品牌  三元表达式
                    that.jbxxForm.brand=res.data.brand ? parseInt(res.data.brand) : null ;
                    //售卖类型
                    if (res.data.sellType!=null){
                        that.cpForm.sellType=res.data.sellType;
                    }
                    that.cpForm.parentSku=res.data.parentSku;
                    that.cpForm.proTitle=res.data.proTitle;
                    that.cpForm.detail=res.data.detail;
                    that.catId=res.data.catId;
                    that.sShopeeValList=res.data.sShopeeValList;
                    that.handleCategory(that,that.catId,res.data.sShopeeValList)
                    //变种信息表格数据转化
                    if (that.bzxx.tableData.length > 0){
                        var value0List=[];
                        var value1List=[];
                        var tableData = that.bzxx.tableData;
                        //遍历表格.获取需要的列数据
                        for (var i=0; i<that.bzxx.tableData.length;i++){
                            var value0 = that.bzxx.tableData[i][0];
                            var value1 = that.bzxx.tableData[i][1];
                            //第一个表格
                            if (value0!=""){
                                if (value0List.indexOf(value0) == -1){
                                    value0List.push(value0);
                                }
                            }
                            //第二个表格
                            if (value1!=""){
                                if (value1List.indexOf(value1) == -1){
                                    value1List.push(value1);
                                }
                            }
                        }
                        //遍历变种信息的属性值
                        for (var i=0; i<that.bzxx.testDynamicAttrList.length;i++){
                            var attrValList0 = null;
                            var valueList=null;
                            //转换值
                            if (i==0 && value0List.length > 0){
                                attrValList0 = that.bzxx.testDynamicAttrList[i].attrVal;
                                valueList=value0List;
                            }else if (i==1 && value1List.length > 0){
                                attrValList0 = that.bzxx.testDynamicAttrList[i].attrVal;
                                valueList=value1List;
                            }
                            // 把checked 设置成true
                            if (attrValList0!=null && valueList!=null){
                                that.bzxx.testDynamicAttrList[i].view=true
                                for (var j=0; j<attrValList0.length;j++){
                                    var attrValName = attrValList0[j].attrValName;
                                    if (valueList.indexOf(attrValName) > -1){
                                        that.bzxx.testDynamicAttrList[i].attrVal[j].checked=true;
                                    }
                                }
                            }
                        }
                    }
                })
            },
            //添加一个空的URL
            addURL() {
                this.xxForm.urls.push("");
            },
            //删除URL
            deletei(index) {
                this.xxForm.urls.splice(index, 1)
            },
            // 产品图片
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log(file);
            },
            handleExceed(files, fileList) {
                this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },
            beforeRemove(file, fileList) {
                return this.$confirm(`确定移除 ${ file.name }？`);
            },
            change(e, index) {
                let defaultValue = event.currentTarget.defaultValue;
                if (e == true && this.count >= 9) {
                    alert("只能选择9张");
                    //取消选中
                    this.picList[index].checked = false;
                    //因为已经点击了checkbox,它的checked=true,所以需要修改为false,不然会进入到false的判断,导致统计数量不准确
                    event.currentTarget.checked = false
                    return
                }
                if (e == false) {
                    //统计选择的图片数量
                    this.count--;
                    //取消选中
                    this.picList[index].checked = false;
                    //如果取消选中,则需要从数组删除指定的ID
                    this.picID.splice(this.picID.indexOf(defaultValue), 1);
                }
                if (e == true) {
                    //统计选择的图片数量
                    this.count++;
                    //把选择的ID保存起来
                    this.picID.push(defaultValue);
                    //设置为选中
                    this.picList[index].checked = true;
                }
            },
            start(e) {
            },
            end(e) {
            },
            //变种信息添加内容
            add() {
                this.bzxx.tableData2.push(
                    {
                        sort: '优惠期间',
                        count1: '',
                        count2: '',
                        price: '',
                    }
                )
            },
            deleteRow(index) {
                this.bzxx.tableData2.splice(index, 1);
            },
            //select 点击触发
            shopNameChange(val){
                this.jbxxForm.shopName=val;
            },
            materialChange (val,index){
                this.jbxxForm.material=val;
            },
            brandChange(val){
                this.jbxxForm.brand=val;
            },
            // styleChange(val){
            //     this.jbxxForm.style=val;
            // },
            // style2Change(val){
            //     this.jbxxForm.style2=val;
            // },
            optionData(data) {
                let cloneData = JSON.parse(JSON.stringify(data))      // 对源数据深度克隆
                return cloneData.filter(father => {                      // 循环所有项，并添加children属性
                    let branchArr = cloneData.filter(child => father.id == child.parentId);       // 返回每一项的子级数组
                    branchArr.length > 0 ? father.children = branchArr : ''   //给父级添加一个children属性，并赋值
                    return father.parentId == 0;      //返回第一层
                });
            },
            //获取本平台树的ID
            getTreeNodeId(val){
                this.xxForm.typeNo=val;
            },
            //shopee平台类目选择确定按钮
            shopeeDialogSubmit(){
                let arrValId = this.getArrValId(this.platType);
                //根据ID获取属性名
                this.getShopeeAttrName(arrValId);
                let join = this.$refs["cascaderAddr"].getCheckedNodes()[0].pathLabels.join(" > ");
                let join2 = this.platType.join(",");
                //清空所有的select值,不然会显示第一次进来的值
                this.jbxxForm.brand = null;
                this.selectValue=[];
                this.selectValueList=[];
                this.sShopeeValList=[];
                //处理类目
                this.handleCategory(this,join2,this.sShopeeValList)
                this.cascaderName=join;
                this.shopeeDialogVisible = false;
            },
            //选择分类
            getPlatTypeTree(){
                this.shopeeDialogVisible = true;
                let params = {
                    platNo:'05',
                }
                getPlatTypeTree(params).then((res) => {
                    let data2 = res.data;
                    this.shopeeOptions=res.data
                    res.data.forEach(items => {
                        if (items.children.length > 0) {
                            this.getTypeList(items.children);
                        } else {
                            items.children = undefined;
                        }
                    });
                    this.getTypeList(this.shopeeOptions);
                    //自动展示级联表
                    this.$nextTick(() => {
                        this.$refs["cascaderAddr"].toggleDropDownVisible(true);
                    });
                })
            },
            //递归把空数组变成undefined,不然会存在空级联的BUG
            getTypeList(shopeeOptions) {
                shopeeOptions.forEach(items => {
                    if (items.children !=undefined && items.children.length > 0) {
                        this.getTypeList(items.children);
                    } else {
                        items.children = undefined;
                    }
                });
            },
            //根据shopee平台ID获取Name
            getShopeeAttrName(id){
                getPlatTypeName(id).then((res) => {
                    this.jbxxForm.cpfl = res.data.catName;
                })
            },
            //把数组分割成字符串并取最后一个
            getArrValId(platType){
                //以逗号分割数组,转成字符串
                let platTypeStr = platType.join(",");
                //取出最后一个逗号后面的ID
                let attrId = platTypeStr.substring(platTypeStr.lastIndexOf(",")+1);
                return attrId;
            },
            //获取类目的最后一级集合
            getLastPlatformCategory(that,list){
                let arrValId = this.getArrValId(that.platType);
                var params1 ={
                    catId:parseInt(arrValId),
                    attrType:'01',
                    isEffect:'1'
                }
                getListByCatId(params1).then((res) => {
                    //每次进来都要清空
                    that.catList=res.data;
                    // that.selectValue=new Array(res.data.length);
                    //遍历shopeeVal集合
                    list.forEach(items1 => {
                        // 遍历产品属性集合
                        that.catList.forEach((items2,index) => {
                            var index = index;
                            //如果attrid相同,则是同一个产品属性
                            if (items2.attrId == items1.attrId ){
                                that.selectValue[index] = items1.valId;
                            }
                        });
                    });
                    that.catList.forEach((items,index) => {
                        var params2 = {
                            attrId:parseInt(items.attrId)
                        }
                        // 遍历产品属性集合
                        getListByAttrId(params2).then((res) => {
                            if ( res.data.length != 0){
                                //在数组指定位置添加数据
                                that.selectValueList.splice(index, 0, res.data);
                            }else{
                                that.selectValueList.splice(index, 0, []);
                            }
                        });
                    });
                })
            },
            //处理类目和属性的动态数据
            handleCategory(that,catId,list){
                if (catId !=  "" && catId != null){
                    //分割数组,在赋值
                    let split = catId.split(",");
                    that.platType=split;
                    //取出最后一个逗号后面的ID
                    let attrId = catId.substring(catId.lastIndexOf(",")+1);
                    that.attrId=attrId;
                    //根据ID获取属性名
                    that.getShopeeAttrName(attrId);
                    that.getLastPlatformCategory(that,list);
                    //根据获取的数组ID,查找各个类目NAME,然后用 ">" 拼接
                    getPlatTypeNames(that.platType).then((res) => {
                        //返回的是字符串,直接放在msg信息体里面
                        that.cascaderName=res.msg
                    })
                    //根据属性的ID获取品牌下拉框
                    var query = {
                        'catId':that.attrId
                    }
                    getList(query).then((res) => {
                        that.brandOption=res.data
                    })

                }
            },
            //覆盖默认上传行为
            requertUpload(data){
                let formData = new FormData();
                formData.append('picType','01');
                this.uploadByPicType(formData,data)
            },
            requertUploadSize(data){
                let formData = new FormData();
                formData.append('picType','02');
                this.uploadByPicType(formData,data)
            },
            beforeUpload(file) {
            },
            //获取照片集合
            getPicList(){
                var params = {
                    'pId':this.$route.query.pId,
                    'picType':'01' //01是普通照片
                }
                getPicListBypId(params).then(res => {
                    if(res.code == 200){
                        this.picList=res.data;
                    }
                }).catch(err => {});
            },
            //上传图片时,区分不同的图片类型参数
            uploadByPicType(formData,data){
                //文件
                formData.append("imageFile", data.file);
                publicUploadImg(formData).then(res => {
                    if(res.code == 200){
                        if (formData.get("picType") == "02"){
                            this.sizePicList.push(res.data)
                            this.uploadDis= false
                        }else{
                            let picList = this.picList;
                            this.picList.push(res.data)
                            // this.$set(this.picList, res.data);
                        }
                        this.msgSuccess(res.msg);
                    }
                }).catch(err => {});
            },
            //移除照片
            deletePic(index){
                this.picList.splice(index,1);
            },
            //获取尺寸照片,如果有尺寸照片,则隐藏上传框
            getSizePic(){
                var params = {
                    'pId':this.$route.query.pId,
                    'picType':'02' //01是尺寸照片,只有一张
                }
                getPicListBypId(params).then(res => {
                    if(res.code == 200){
                        if (res.data.length != 0){
                            this.uploadDis=false;
                        }
                        this.sizePicList=res.data;
                    }
                }).catch(err => {});
            },
            //移除尺寸照片
            deleteSiezPic(){
                this.sizePicList=[];
                this.uploadDis=true;
            },
            //导出全部图片
            downloadZip(){
                downLoadZip("/product/shopee/downloadZip?pId="+this.$route.query.pId);
            },
            //变种信息checked事件
            bzxxChecked(val,attrIndex,attrValIndex){
                this.$set(this.bzxx.testDynamicAttrList[attrIndex].attrVal[attrValIndex], 'checked', val);
                //动态展示表格列
                this.DynamicTableColumn(val,attrIndex,this.bzxx.testDynamicAttrList[attrIndex].attrVal[attrValIndex].attrValName);
            },
            bzxxDeletePic(attrIndex,attrValIndex){
                this.$set(this.bzxx.testDynamicAttrList[attrIndex].attrVal[attrValIndex], 'picUrl', '');
            },
            bzxxUpload(item,val){
                let formData = new FormData();
                formData.append("imageFile", val.file);
                let ss = JSON.stringify(item);
                formData.append("item", JSON.stringify(item));
                bzxxPicUpload(formData).then(res => {
                    //手动调用成功回调函数
                    val.onSuccess(res.data);
                }).catch(err => {});

            },
            //上传成功回调
            handleBannerSuccess(testDynamic,index, data) {
                // this.bzxx.colorList[index]=data;  这种方法不会触发VUE的动态更新数据
                this.$set(testDynamic.attrVal,index,data);   //这种方法可以触发更新
            },
            //获取变种信息颜色集合
            getBzxxColor(){
                getBzxxColor().then(res => {
                    this.bzxx.colorList=res.data
                }).catch(err => {});
            },
            //获取变种信息SZIE集合
            getBzxxSize(){
                getBzxxSize().then(res => {
                    this.bzxx.sizeList=res.data
                }).catch(err => {});
            },
            //添加属性值
            addValName(testDynamicIndex){
                let testDynamicAttrList = this.bzxx.testDynamicAttrList[testDynamicIndex];
                let inputValName = testDynamicAttrList.attrValInputName;
                let attrName = testDynamicAttrList.attrName;
                //判断固定的Color和Size不能重复添加
                if (attrName=='Color'){
                    for (var i=0; i<this.bzxx.colorList.length;i++){
                        if (inputValName == this.bzxx.colorList[i].attrValName){
                            this.msgError("已有重复的属性值");
                            return;
                        }
                    }
                }else if (attrName=='Size'){
                    for (var i=0; i<this.bzxx.sizeList.length;i++){
                        if (inputValName == this.bzxx.sizeList[i].attrValName){
                            this.msgError("已有重复的属性值");
                            return;
                        }
                    }
                }

                if (inputValName === '' || inputValName.split(" ").join("").length==0){
                    this.msgError("属性值不能为空");
                    return
                }
                //判断属性值是否存在
                for (var items of this.bzxx.testDynamicAttrList[testDynamicIndex].attrVal) {
                    if (inputValName === items.attrValName){
                        this.msgError("已有重复的属性值");
                        this.$set(this.bzxx.testDynamicAttrList[testDynamicIndex],"attrValInputName",'');
                        return
                    }
                }
                //添加一个属性值
                this.bzxx.testDynamicAttrList[testDynamicIndex].attrVal.push(
                    {
                        attrValName:inputValName,
                        edit:false,
                        backupName:'',
                        checked:true,
                        colorOrSize:'1', //判断是不是属于原始的颜色组
                        picUrl:'',
                    }
                )
                this.DynamicTableColumn(true,testDynamicIndex,inputValName)
            },
            //修改属性值的名字 attrIndex:属性名的索引,attrValIndex:属性值的索引
            iconEdit(attrIndex,attrValIndex){
                //把备份的name展示出
                let attrVal = this.bzxx.testDynamicAttrList[attrIndex].attrVal[attrValIndex];
                this.$set(this.bzxx.testDynamicAttrList[attrIndex].attrVal[attrValIndex],"edit",true);
                this.$set(this.bzxx.testDynamicAttrList[attrIndex].attrVal[attrValIndex],"backupName",attrVal.attrValName);
            },
            //图标保存属性名 attrIndex:属性名的索引,attrValIndex:属性值的索引
            iconSave(attrIndex,attrValIndex){
                //如果点击了保存,则把备份的NAME赋值给正常显示的NAME
                let backupName = this.bzxx.testDynamicAttrList[attrIndex].attrVal[attrValIndex].backupName;
                let attrValName = this.bzxx.testDynamicAttrList[attrIndex].attrVal[attrValIndex].attrValName;
                let attrVal = this.bzxx.testDynamicAttrList[attrIndex].attrVal;
                //判断空格
                if (backupName.split(" ").join("").length==0){
                    this.msgError("属性名不能为空");
                    this.$set(this.bzxx.testDynamicAttrList[attrIndex].attrVal[attrValIndex],"backupName",attrValName);
                    this.$set(this.bzxx.testDynamicAttrList[attrIndex].attrVal[attrValIndex],"edit",true);
                    return
                }
                //修改名字时,要与其他做比较,不能有相同的名字
                for (var i=0;i < attrVal.length;i++) {
                    if (backupName == attrVal[i].attrValName && i!=attrValIndex){
                        this.msgError("属性名不能相同");
                        this.$set(this.bzxx.testDynamicAttrList[attrIndex].attrVal[attrValIndex],"backupName",attrValName);
                        this.$set(this.bzxx.testDynamicAttrList[attrIndex].attrVal[attrValIndex],"edit",true);
                        return;
                    }
                }
                //赋值
                this.$set(this.bzxx.testDynamicAttrList[attrIndex].attrVal[attrValIndex],"attrValName",backupName);
                //取消编辑状态
                this.$set(this.bzxx.testDynamicAttrList[attrIndex].attrVal[attrValIndex],"edit",false);
                //修改名字时,也要把表格的名字修改
                for (var i=0;i < this.bzxx.tableData.length;i++) {
                    //以前的名字
                    let oldName = this.bzxx.tableData[i][attrIndex];
                    if (oldName == attrValName){
                        //根据索引获取数据
                        let tableDatum = this.bzxx.tableData[i];
                        // 修改数据
                        tableDatum[attrIndex]=backupName
                        // this.$set(tableData,index,row)
                        this.$set(this.bzxx.tableData,i,tableDatum);
                    }

                }
            },
            //取消保存 attrIndex:属性名的索引,attrValIndex:属性值的索引
            iconCancel(attrIndex,attrValIndex){
                this.$set(this.bzxx.testDynamicAttrList[attrIndex].attrVal[attrValIndex],"backupName","");
                this.$set(this.bzxx.testDynamicAttrList[attrIndex].attrVal[attrValIndex],"edit",false);
            },
            //删除color或者Size
            deleteColorOrSize(){
                let testDynamicAttrList = this.bzxx.testDynamicAttrList;
                for (var item of testDynamicAttrList){
                    if (item.attrType=='2'){
                        for (var i=0; i<this.bzxx.AttrList.length;i++){
                            if (this.bzxx.AttrList[i].name=='Color'){
                                this.bzxx.AttrList.splice(i, 1);
                            }
                        }
                    }else if (item.attrType=='3'){
                        for (var i=0; i<this.bzxx.AttrList.length;i++){
                            if (this.bzxx.AttrList[i].name=='Size'){
                                this.bzxx.AttrList.splice(i, 1);
                            }
                        }
                    }
                }
            },
            //打开添加自定义属性
            addAttr(){
                this.bzxx.attrDig=true;
            },
            //提交增加一个属性,不属于Color和Size
            addAttrSubmit(){
                let attrInputName = this.bzxx.attrInputName;
                if (attrInputName == '' || attrInputName == null){
                    this.msgError("属性名不能为空");
                    return;
                }
                this.bzxx.testDynamicAttrList.push(
                    {
                        attrName:attrInputName,
                        attrVal:[],
                        attrValInputName:'',
                        attrType:'1', //判断是不是属于原始的颜色组
                        view:false,
                        DynamicAttrName:'',//动态的列展示数据属性
                    }
                )
                this.bzxx.attrDig=false;
            },
            //移除属性值
            removeAttr(testDynamicIndex){
                let testDynamicAttrList = this.bzxx.testDynamicAttrList[testDynamicIndex];
                //移除时添加会出现重复的Color和Size,所以先遍历把重复的删除,然后再进行添加
                var attrType;
                if (testDynamicAttrList.attrType=='2'){
                    attrType = 'Color';
                }else if (testDynamicAttrList.attrType=='3'){
                    attrType = 'Size';
                }
                //遍历删除相同的添加项
                for (var i=0; i<this.bzxx.AttrList.length;i++){
                    if (this.bzxx.AttrList[i].name==attrType){
                        this.bzxx.AttrList.splice(i,1);
                    }
                }
                //增加color或者Size 2:Color,3:Size
                if (testDynamicAttrList.attrType == '2' || testDynamicAttrList.attrType == '3' ){
                    this.bzxx.AttrList.push(
                        {
                            name:attrType
                        }
                    )
                }
                //移除时操作表格动态数据
                this.removeAttrChangeTableData(testDynamicIndex);
                //把点击的属性名移除
                this.bzxx.testDynamicAttrList.splice(testDynamicIndex,1);
            },
            //点击添加特有的Color和Size
            addColorAndSize(name,index){
                var attrType;
                if (name == 'Color'){
                    attrType = '2'
                }else{
                    attrType='3'
                }
                this.bzxx.AttrList.splice(index, 1);
                this.bzxx.testDynamicAttrList.push(
                    {
                        attrName:name,
                        attrVal:[],
                        attrValInputName:'',
                        attrType:attrType, //判断是不是属于原始的颜色组
                        view:false,
                        DynamicAttrName:'',//动态的列展示数据属性
                    }
                )
            },
            //勾选固定的Color和Size,然后添加到attVal集合里,为false则遍历删除
            addColorOrSizePic(val,attrValName,type,testDynamicIndex){
                let list = this.bzxx.testDynamicAttrList[testDynamicIndex].attrVal;
                if (val){
                    list.push(
                        {
                            attrValName:attrValName,
                            edit:false,
                            backupName:'',
                            checked:val,
                            colorOrSize:type, //判断是不是属于原始的颜色组
                            picUrl:'',
                        }
                    )
                }else{
                    for (var i=0;i < list.length;i++) {
                        //如果有颜色相同的则删除
                        if (list[i].attrValName == attrValName){
                            list.splice(i,1);
                            break;
                        }
                    }
                }
                this.DynamicTableColumn(val,testDynamicIndex,attrValName)
            },
            //动态展示表格的列
            DynamicTableColumn(val,testDynamicIndex,attrValName){
                //根据索引取反向的集合索引
                var index =testDynamicIndex;
                if (testDynamicIndex==0){
                    index+=1;
                }else {
                    index-=1;
                }
                let testDynamicAttrList = this.bzxx.testDynamicAttrList[testDynamicIndex];
                let attrVal = testDynamicAttrList.attrVal;
                if (val){
                    var view = false;
                    //遍历查看是否有存在的勾选的属性值
                    for (var i=0;i < attrVal.length;i++) {
                        //如果有颜色相同的则删除
                        if (attrVal[i].checked==true){
                            view =true;
                            break;
                        }
                    }
                    //修改主题框的VIEW
                    this.$set(this.bzxx.testDynamicAttrList[testDynamicIndex],"view",view);
                    this.manyToMany(testDynamicIndex,attrValName,index);
                }else{
                    //用来判断是否隐藏整列
                    var i2=0;
                    //判断是否全部都为false,如果全部是false,则隐藏整列
                    for (var i=0;i < attrVal.length;i++) {
                        if (attrVal[i].checked==false){
                            i2++;
                        }
                    }
                    //取消勾选,循环删除所有同名的数据
                    for (var i=0;i< this.bzxx.tableData.length;i++) {
                        let item = this.bzxx.tableData[i][testDynamicIndex];
                        if (this.bzxx.tableData[i][testDynamicIndex]==attrValName){
                            this.bzxx.tableData.splice(i,1);
                            //因为删除会一直减1,所以要做想应该的操作减1
                            i-=1;
                        }
                    }
                    //如果与属性值的size相等,则隐藏整列
                    if (i2==attrVal.length){
                        this.$set(this.bzxx.testDynamicAttrList[testDynamicIndex],"view",false);
                    }
                    //获取索引的反向集合
                    let testDynamicAttrLists = this.bzxx.testDynamicAttrList[index];
                    let attrVals = testDynamicAttrLists.attrVal;
                    for (var i=0;i < attrVals.length;i++) {
                        if (attrVals[i].checked==true && i2==attrVal.length){
                            this.shareTableData(this.bzxx.tableData,index,testDynamicIndex,'',attrVals[i].attrValName)
                        }
                    }
                }
            },
            //多对多数据
            manyToMany(testDynamicIndex,attrValName,index){
                //是否为单增加
                var isAdd=false;
                //是否为多对多增加
                var many =false;
                let testDynamicAttrList = this.bzxx.testDynamicAttrList[index];
                if (testDynamicIndex==0 || testDynamicIndex==1 ){
                    if (testDynamicAttrList !=null && testDynamicAttrList !=undefined){
                        let attrVal = testDynamicAttrList.attrVal;
                        //遍历查看是否有存在的勾选的属性值
                        for (var i=0;i < attrVal.length;i++) {
                            //选中才赋值
                            if (attrVal[i].checked==true){
                                this.bzxx.tableData.forEach(items => {
                                    let itemss = items[testDynamicIndex];
                                    if (items[testDynamicIndex] == ''){
                                        isAdd=true;
                                        many=true;
                                        items[testDynamicIndex]=attrValName
                                    }
                                })
                                if (many==false){
                                    isAdd=true
                                    this.shareTableData(this.bzxx.tableData,index,testDynamicIndex,attrValName,attrVal[i].attrValName)
                                }
                            }
                        }
                        //根据索引新添加一个tabledata
                        if (isAdd==false){
                            this.shareTableData(this.bzxx.tableData,index,testDynamicIndex,attrValName,'')
                        }
                    }else {
                        this.shareTableData(this.bzxx.tableData,index,testDynamicIndex,attrValName,'')
                    }
                }
            },
            //共享的添加动态表格数据
            shareTableData(tableList,index,testDynamicIndex,attrValName,indexValue){
                let length = tableList.length;
                tableList.push(
                    {
                        sku:'',
                        price:'',
                        switchValue:false,
                        promPrice:'',
                        discount:'',
                        invent:'',
                    }
                );
                //给原来的索引赋值
                this.bzxx.tableData[length][testDynamicIndex]=attrValName;
                //给值变化后的索引赋值
                this.bzxx.tableData[length][index]=indexValue;
            },
            //移除变种主题时操作表格动态数据
            removeAttrChangeTableData(testDynamicIndex){
                //获取反向集合索引
                let index =testDynamicIndex;
                if(index == 0){
                    index+=1
                }else {
                    index-=1
                }
                //清空表格
                this.bzxx.tableData=[];
                //获取反向集合
                let testDynamicAttrList = this.bzxx.testDynamicAttrList[index];
                //判断反向集合是否为空
                if (testDynamicAttrList !=null && testDynamicAttrList !=undefined){
                    //获取属性值集合
                    let attrVal = testDynamicAttrList.attrVal;
                    //遍历属性值
                    for (var i=0;i < attrVal.length;i++) {
                        let checked = attrVal[i].checked;
                        let attrValName = attrVal[i].attrValName;
                        if (checked == true){
                            //添加一条数据
                            this.shareTableData(this.bzxx.tableData,1,0,attrValName,'');
                        }
                    }
                }

            },
            //SKU自动生成
            AutomaticGeneration(){
                let parentSku = this.cpForm.parentSku;
                if (parentSku==null){
                    this.msgError("parentSku为空,自动生成失败");
                    return false
                }
                let tableData = this.bzxx.tableData;
                for (var i=0;i < tableData.length;i++) {
                    var sku=parentSku;
                    for (var i_2=0;i_2 < this.bzxx.attrNameList.length;i_2++) {
                        var column = "column_"+i_2
                        let newVar = tableData[i][column];
                        sku+="-"+newVar
                    }
                    tableData[i].skuno=sku
                }
            },
            //打开弹框,获取第一个焦点
            updatePriceDig(){
                this.bzxx.updatePriceDig=true;
                this.$nextTick(() => {
                    this.$refs.priceInput_1.focus();
                })
            },
            //选择修改价钱的方式,禁止输入不被选择的那个
            priceRadioChange(e){
                if (e==0){
                    this.bzxx.priceRadioDisabled_1=false
                    this.bzxx.priceRadioDisabled_2=true
                    this.$nextTick(() => {
                        this.$refs.priceInput_1.focus();
                    })
                }else{
                    this.bzxx.priceRadioDisabled_1=true
                    this.bzxx.priceRadioDisabled_2=false
                }
            },
            //打开修改库存弹框,获取第一个焦点
            updateInventDig(){
                this.bzxx.updateInventDig=true;
                this.$nextTick(() => {
                    this.$refs.inventInput_1.focus();
                })
            },
            //选择修改库存的方式,禁止输入不被选择的那个
            inventRadioChange(e){
                if (e==0){
                    this.bzxx.inventRadioDisabled_1=false
                    this.bzxx.inventRadioDisabled_2=true
                    this.$nextTick(() => {
                        this.$refs.inventInput_1.focus();
                    })
                }else{
                    this.bzxx.inventRadioDisabled_1=true
                    this.bzxx.inventRadioDisabled_2=false
                }
            },
            // sku批量修改
            batchUpdateSKu(vaule_1,vaule_2){
                let tableData = this.bzxx.tableData;
                for (var i=0;i < tableData.length;i++) {
                    var sku=parentSku;
                    if (vaule_1=="0" && vaule_2=="1" ){
                        var name_1 = tableData[i][vaule_1];
                        var name_2 = tableData[i][vaule_2];
                        if (name_1!=""){
                            sku+="-"+name_1
                        }
                        if (name_2!=""){
                            sku+="-"+name_2
                        }
                        tableData[i].sku=sku
                    }else {
                        tableData[i].sku=sku
                    }

                }
            },
            //提交价格
            sumbitPrice(){
                let priceRadio = this.bzxx.priceRadio;
                let tableData = this.bzxx.tableData;
                if (priceRadio==0){
                    let priceInput1 = this.bzxx.priceInput_1;
                    if (priceInput1!=null){
                        //检测是否有多个.
                        let checkInputValue2 = this.checkInputValue(priceInput1);
                        if (checkInputValue2==false && checkInputValue2!=0){
                            return
                        }
                        //最终处理好的值
                        let handlePrice2 = this.handlePrice(priceInput1);
                        //循环修改价格
                        for (var i=0;i < tableData.length;i++) {
                            tableData[i].price=handlePrice2
                        }
                        this.restPrice();
                    }
                }else{
                    let priceInput2 = this.bzxx.priceInput_2;
                    let priceTypeValue = this.bzxx.priceTypeValue;
                    if (priceInput2!=null){
                        //最终处理好的值
                        var handlePrice2 = this.handlePrice(priceInput2);
                        //在金额基础上加
                        if (priceTypeValue==0){
                            let checkInputValue3 = this.checkInputValue(priceInput2);
                            if (checkInputValue3==false && checkInputValue3!=0){
                                return
                            }
                            //循环修改价格
                            var sum=0;
                            for (var i=0;i < tableData.length;i++) {
                                let price = tableData[i].price;
                                //不为空
                                if (price!=''){
                                    //处理表格的数据
                                    var handleDataPrice2 = this.handleDataPrice(price);
                                    sum = this.accAdd(handleDataPrice2,handlePrice2)
                                    var s = sum.toFixed(2);
                                    tableData[i].price=s+"";
                                }else{
                                    tableData[i].price=handlePrice2;
                                }
                            }
                            this.restPrice();
                        }else{
                            //按百分比加
                            var little =Number(parseFloat(priceInput2));
                            var s =little.toFixed(2);
                            for (var i=0;i < tableData.length;i++) {
                                var price = tableData[i].price;
                                //处理表格的数据
                                var handleDataPrice2 = this.handleDataPrice(price);
                                if (price!='' && price!="0.00"){
                                    var little2 =Number(parseFloat(price));
                                    var s2 =little2.toFixed(2);
                                    //因为是百分比,所以先剩0.01
                                    let accMul3 = this.accMul(s,0.01);
                                    //最终的增加价格
                                    var accMul2 = this.accMul(s2,accMul3);
                                    //用原来的加上最终的
                                    var accAdd2 = this.accAdd(s2,accMul2);
                                    var toFixed = accAdd2.toFixed(2);
                                    tableData[i].price=toFixed+"";
                                }
                            }
                            this.restPrice();
                        }
                    }

                }
            },
            //取消价格框
            cancelPrice(){
                this.restPrice();
            },
            // 重置修改价格表单
            restPrice(){
                this.bzxx.updatePriceDig=false;
                this.bzxx.priceInput_1=null;
                this.bzxx.priceInput_2=null;
                this.bzxx.priceTypeValue=0;
                this.bzxx.priceRadio=0;
                this.bzxx.priceRadioDisabled_1=false;
                this.bzxx.priceRadioDisabled_2=true;
            },
            // 重置修改价格表单
            restInvent(){
                this.bzxx.updateInventDig=false;
                this.bzxx.inventInput_1=null;
                this.bzxx.inventInput_2=null;
                this.bzxx.inventTypeValue=0;
                this.bzxx.inventRadio=0;
                this.bzxx.inventRadioDisabled_1=false;
                this.bzxx.inventRadioDisabled_2=true;
            },
            //验证是否有多个.
            checkInputValue(inputValue){
                var littleSize=0;
                for (var i = 0; i < inputValue.length; i++) {
                    // if (inputValue.charAt(0)=="."){
                    //     inputValue="0"+inputValue;
                    // }
                    if (inputValue.charAt(i) == "."){
                        littleSize++;
                    }
                    if (littleSize>1){
                        this.bzxx.updatePriceDig=false;
                        this.bzxx.priceInput_1=null;
                        return false;
                    }
                }
                return inputValue;
            },
            //处理小数
            handlePrice(priceInput1){
                // //查看是否存在.字符
                // let index = priceInput1.lastIndexOf(".")
                // var before='';
                // if (index < 0){
                //     before=priceInput1;
                //     //整数补连个00
                //     // priceInput1+=".00";
                // }else{
                //     before = priceInput1.substring(0,index);
                // }
                // //处理前面的整数
                // if (before.length>=2){
                //     //如果值第一个为0则遍历清除掉
                //     let eq_0 = before.charAt(0);
                //     if (eq_0==0){
                //         //定义一个值获取0的长度
                //         var Indexes =0;
                //         //遍历字符串,把前面是0的全部去掉
                //         for (var i = 0; i < before.length; i++) {
                //             let beforeValue = before.charAt(i);
                //             //!= 0 退出循环
                //             if (beforeValue!=0){
                //                 break
                //             }else {
                //                 Indexes++
                //             }
                //         }
                //         //根据索引得出清除0的数据
                //         if (Indexes!=0){
                //             before = before.substring(Indexes,before.length);
                //             priceInput1= before+".00";
                //         }
                //     }
                // }else{
                //     //如果只有一个整数,没有小数则变成 值.00
                //     if (before.length==1 && index<0){
                //        return before+".00";
                //     }
                //
                // }
                // //处理后面的小数
                // if (index > 0){
                //     // 截取后的小数
                //     let littleNumber = priceInput1.substring(index+1,priceInput1.length);
                //     //输入值.的情况
                //     if (littleNumber==''){
                //         priceInput1=before+".00";
                //     }
                //     //长度
                //     let size = littleNumber.length;
                //     //>=3,满5则进位
                //     if (size>=3){
                //         //.后面两个小数
                //         let two = littleNumber.substring(0,2);
                //         //.第三个小数
                //         let one = littleNumber.substring(2,3);
                //         //第三个小数大于1,则进1
                //         if (one >= 5){
                //             parseInt(two);
                //             two++;
                //             //如果小数满100了,则应该向整数进1
                //             if(two == 100){
                //                 parseInt(before);
                //                 before++
                //                 two="00";
                //             }
                //         }
                //         priceInput1=before+"."+two;
                //     }else if (size == 1){
                //         //==1 则补0
                //         priceInput1=before+"."+littleNumber+"0";
                //     }
                // }
                var little =Number(parseFloat(priceInput1));
                priceInput1 =little.toFixed(2)+"";
                return priceInput1;
            },
            // 处理增加前的金额
            handleDataPrice(price){
                let index = price.lastIndexOf(".")
                // 截取后的小数
                let littleNumber = price.substring(index+1,price.length);
                if (price.length==1 && index<1){
                    return price+".00";
                }else if (littleNumber==''){
                    return price+"00";
                }else if (littleNumber.length==1){
                    return price+"0";
                }
                return price
            },
            //小数相加
            accAdd(arg1, arg2) {
                var r1, r2, m;
                try {
                    r1 = arg1.toString().split(".")[1].length
                } catch (e) {
                    r1 = 0
                }
                try {
                    r2 = arg2.toString().split(".")[1].length
                } catch (e) {
                    r2 = 0
                }
                // 这里Math.max(r1, r2)取最长的小数位
                // Math.ceil(length / 3) * 3) 按照位数计算乘以的倍数.比如 2 => 1000, 4 => 1000000
                m = Math.pow(10, Math.ceil(Math.max(r1, r2) / 3) * 3)
                return (arg1 * m + arg2 * m) / m
            },
            //小数相乘
            accMul(arg1,arg2) {
                var m=0,s1=arg1.toString(),s2=arg2.toString();
                try{m+=s1.split(".")[1].length}catch(e){}
                try{m+=s2.split(".")[1].length}catch(e){}
                return Number(s1.replace(".",""))*Number(s2.replace(".",""))/Math.pow(10,m)
            },
            //提交库存量的更改
            sumbitInvent(){
                var inventRadio = this.bzxx.inventRadio;
                var tableData = this.bzxx.tableData;
                var intValue=0
                if (inventRadio==0){
                    var inventInput1 = this.bzxx.inventInput_1;
                    if(inventInput1!=null){
                        intValue =parseInt(inventInput1);
                        for (var i=0;i < tableData.length;i++) {
                            tableData[i].invent=intValue+"";
                        }
                        this.restInvent();
                    }
                }else {
                    var inventInput2 = this.bzxx.inventInput_2;
                    if(inventInput2!=null){
                        intValue =parseInt(inventInput2);
                        for (var i=0;i < tableData.length;i++) {
                            var invent =null;
                            if (tableData[i].invent!=""){
                                invent =parseInt(tableData[i].invent)
                            }
                            if (invent!=null){
                                //最终的值
                                var value;
                                //小于0,则是负数,则减掉
                                if (intValue<0){
                                    value=invent+intValue;
                                    if (value < 0){
                                        value=0;
                                    }
                                }else{
                                    //不是负数则是增加
                                    value = invent+intValue;
                                }
                                tableData[i].invent=value+"";
                            }else{
                                tableData[i].invent=intValue+"";

                            }
                        }
                        this.restInvent();
                    }

                }
            },
            //取消修改库存弹出框
            cancelInvent(){
                this.bzxx.updateInventDig=false;
                this.restInvent();
            },
            //包装与运输的长宽高校验
            limitNumber(e,name){

                if (e!=null && e>100000){
                    if (name=='long'){
                        this.bzyys.formLabelAlign.packLong=100000
                    }else if (name=='wide'){
                        this.bzyys.formLabelAlign.packWide=100000

                    }else if (name=='high'){
                        this.bzyys.formLabelAlign.packHigh=100000
                    }
                }
            },
            //提交保存 isRelease:是否移入待发布 0:否,1:是
            save(isRelease){
                // this.loading = true;
                // this.$loading(body)
                this.startLoading()
                var msg = "";
                this.$refs.cpForm.validate((valid) => {
                    if (!valid) {
                        msg+="产品信息,"
                    }
                })
                this.$refs.bzxx.validate((valid) => {
                    if (!valid) {
                        msg+="多件优惠,"
                    }
                });
                this.$refs.BzyysFormLabelAlign.validate((valid) => {
                    if (!valid) {
                        msg+="包装运输,"
                    }
                })
                if (msg!=""){
                    msg+="模块缺少必填信息"
                    this.msgError(msg);
                    this.endLoading()
                    return
                }
                if (this.bzxx.tableData.length <=0){
                    this.msgError("变种信息不能为空");
                    this.endLoading()
                    return
                }
                this.jbxxForm
                this.catList;
                this.xxForm
                this.cpForm
                this.picList
                this.sizePicList
                this.bzyys.formLabelAlign
                this.selectValue;
                var tableData = this.bzxx.tableData
                tableData.map(item =>{
                    item._0=item[0];
                    item._1=item[1];
                    delete item[0];
                    delete item[1];
                    return
                })
                const data = Object.assign(this.jbxxForm, this.xxForm,this.cpForm,this.bzyys.formLabelAlign);
                data.picList=this.picList;
                data.selectValue=this.selectValue;
                data.sizePicList=this.sizePicList;
                data.tableData=tableData;
                data.pId=this.$route.query.pId;
                data.isRelease = isRelease
                data['tableDataMap']=this.bzxx.tableData;
                data['dynamicAttrList']=this.bzxx.testDynamicAttrList;
                data['attrNameList']=this.bzxx.attrNameList;
                //别的平台分类数组,需要用逗号隔开转成字符串
                var platType = this.platType;
                if (platType!=null){
                    platType = platType.join(",");
                }
                data.platType = platType;
                saveEdit(data).then(res => {
                    this.loadData(this);
                    this.endLoading();
                    this.msgSuccess(res.msg);
                }).catch(err => {
                    this.endLoading();
                });

            },
            //锚点
            sideBarTool(){
                var aNav = $('#LoutiNav li');
                var aDiv = $('#main .t_plane');
                $(window).scroll(function(){
                    var winH = $(window).height();//可视窗口高度
                    var iTop = $(window).scrollTop();//鼠标滚动的距离
                    aDiv.each(function(){
                        if(winH+iTop - $(this).offset().top>winH - 200){
                            aNav.removeClass('active');
                            aNav.eq($(this).index()).addClass('active');
                        }
                    })
                });
                //点击回到对应面板
                aNav.click(function(){
                    var t = aDiv.eq($(this).index()).offset().top  - 199; 100
                    $('body,html').animate({"scrollTop":t},500);
                    $(this).addClass('active').siblings().removeClass('active');
                });
            },
            //发布
            release(){
                this.msgSuccess("尚在开发");
            },
            checkAttr(val,attrIndex,attrValIndex){
                this.$set(this.bzxx.testDynamicAttrList[attrIndex].attrVal[attrValIndex], 'checked', val);
                var attrVal = this.bzxx.testDynamicAttrList[attrIndex].attrVal[attrValIndex].attrValName;
                //为false
                if (!val){
                    var column ="column_"+attrIndex;
                    for (var i=0; i<this.bzxx.tableData.length;i++ ){
                        //如果只有一列,则直接赋值_0
                        if(this.bzxx.attrNameList.length == 1){
                            column = 'column_0';
                        }
                        let column2 = this.bzxx.tableData[i][column];
                        if (attrVal == column2){
                            this.bzxx.tableData.splice(i,1);
                            i--;
                        }
                    }
                    this.false_checkTableData(attrIndex,attrValIndex);
                }else{
                    this.true_deleteTableData(attrIndex,attrValIndex);
                    this.tableDataColumn(attrIndex,attrVal);
                }
                //检测列
                this.checkColumn();
            },
            //为false时检测是否还包含有选择的属性值
            false_checkTableData(attrIndex,attrVal){
                let attrVal2 = this.bzxx.testDynamicAttrList[attrIndex].attrVal;
                var flag=false;
                for (var j=0; j<attrVal2.length;j++){
                    if (attrVal2[j].checked==true && attrVal!=j){
                        flag=true;
                    }
                }
                if (!flag){
                    this.tableDataColumn(-1,-1);
                }
            },
            //新增集合的第二个属性值时,清空之前的tableData数据
            true_deleteTableData(attrIndex,attrVal){
                let attrVal2 = this.bzxx.testDynamicAttrList[attrIndex].attrVal;
                var flag=false;
                for (var j=0; j<attrVal2.length;j++){
                    if (attrVal2[j].checked==true && attrVal!=j){
                        flag=true;
                    }
                }
                if (!flag){
                    this.bzxx.tableData=[];
                }
            },
            //动态表格
            tableDataColumn(attrIndex,attrVal){
                let testDynamicAttrList = this.bzxx.testDynamicAttrList;
                var dke = [];
                this.bzxx.attrNameList=[];
                for (var i=0; i<testDynamicAttrList.length;i++ ){
                    let attrName = testDynamicAttrList[i].attrName;
                    var atttValueList =[];
                    if (attrIndex == i){
                        atttValueList.push(attrVal);
                        this.bzxx.attrNameList.push(attrName);
                        dke.push(atttValueList);
                        continue;
                    }
                    for (var j=0; j<testDynamicAttrList[i].attrVal.length;j++){
                        if (testDynamicAttrList[i].attrVal[j].checked){
                            atttValueList.push(testDynamicAttrList[i].attrVal[j].attrValName);
                        }
                    }
                    if (atttValueList.length > 0){
                        dke.push(atttValueList);
                        this.bzxx.attrNameList.push(attrName);
                    }
                }
                if (dke.length > 0){
                    //处理笛卡尔积
                    var calcDescartes2 = calcDescartes(dke);
                    let tableData2 = this.bzxx.tableData;
                    for (var i=0; i<calcDescartes2.length;i++ ){
                        var calcDescartes3 = calcDescartes2[i];
                        var columnList={}
                        if (calcDescartes3.constructor==Array){
                            //动态列的数据
                            for (var j=0; j<calcDescartes3.length;j++){
                                var columnName='column_'+j;
                                columnList[columnName]=calcDescartes3[j];
                            }
                        }else {
                            columnList['column_0']=calcDescartes3;
                        }
                        //基本数据
                        var tableData={
                            discount: null,
                            invent: null,
                            price: null,
                            promPrice: null,
                            skuno: null,
                            switchValue: false,
                            skuid:null,
                        }
                        //合并对象
                        var assign = Object.assign(columnList,tableData);
                        this.bzxx.tableData.push(assign)
                    }
                }
                this.checkColumn();
            },
            //检测选择为false时,是否还保留动态列
            checkColumn(){
                let testDynamicAttrList = this.bzxx.testDynamicAttrList;
                for (var i=0; i<testDynamicAttrList.length;i++ ){
                    var flag = false;
                    let attrName = testDynamicAttrList[i].attrName;
                    for (var j=0; j<testDynamicAttrList[i].attrVal.length;j++){
                        if (testDynamicAttrList[i].attrVal[j].checked==true){
                            flag=true;
                        }
                    }
                    if (!flag){
                        for (var j=0; j<this.bzxx.attrNameList.length;j++){
                            if (this.bzxx.attrNameList[j]==attrName){
                                this.bzxx.attrNameList.splice(j, 1);
                            }
                        }
                    }
                }
            },
            //获取公共变种主题
            getPublicAttr(){
                getPublicAttr().then(res => {
                    this.bzxx.colorList=res.data.Color;
                    this.bzxx.sizeList=res.data.Size;
                }).catch(err => {});
            },
            //添加公用的变种主题时的操作
            addColorAndSize_2(name,index){
                //添加后需要删除对应的显示
                this.bzxx.AttrList.splice(index,1);
                var attrType = this.nameByCode(name);
                let attrValList;
                var id ='';
                if (name=="Color"){
                    //数据深度拷贝
                    attrValList =JSON.parse(JSON.stringify(this.bzxx.colorList));
                    id=this.bzxx.colorId;
                }else{
                    //数据深度拷贝
                    attrValList =JSON.parse(JSON.stringify(this.bzxx.sizeList))
                    id=this.bzxx.sizeId;
                }
                this.bzxx.testDynamicAttrList.push(
                    {
                        attrName:name,
                        attrVal:attrValList,
                        attrValInputName:'',
                        attrType:attrType, //判断是不是属于原始的颜色组
                        view:false,
                        DynamicAttrName:'',//动态的列展示数据属性
                        id:'',
                        attrId:id, //固定的变种ID,只有固定的变种才有
                    }
                )
            },
            //公用变种主题根据NAME转化为CODE
            nameByCode(name){
                var attrType;
                if (name == 'Color'){
                    attrType = '2'
                }else if (name == 'Size'){
                    attrType='3'
                }
                return attrType;
            },
            //移除变种主题
            removeAttr_2(index){
                this.$confirm('是否确认把该属性移除吗', "警告", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(function() {
                    return true;
                }).then(() => {
                    //先获取值
                    var testDynamicAttrList = this.bzxx.testDynamicAttrList[index];
                    //如果删除的指定项里面有公用的值,则需要往集合里面添加一个回来
                    if (testDynamicAttrList.attrType=='2'){
                        this.bzxx.AttrList.unshift(
                            {
                                name:'Color',
                            },
                        );
                    }else if (testDynamicAttrList.attrType=='3'){
                        this.bzxx.AttrList.push(
                            {
                                name:'Size',
                            },
                        );
                    }
                    //删除移除的属性数据
                    let removePublic = this.remove_public(index);
                    //把点击的属性名移除
                    this.bzxx.testDynamicAttrList.splice(index,1);
                    if (removePublic){
                        //重新描绘表格
                        this.tableDataColumn(-1,-1);
                    }
                    this.msgSuccess("移除成功");
                }).catch(function() {});
            },
            //移除时的公用方法
            remove_public(index){
                var column ="column_"+index;
                var attrValList = this.bzxx.testDynamicAttrList[index].attrVal;
                var flag = false;
                for (var i=0; i<attrValList.length;i++ ){
                    var attrValName = attrValList[i].attrValName;
                    if (attrValList[i].checked==true){
                        for (var j=0; j<this.bzxx.tableData.length;j++ ){
                            var column2 = this.bzxx.tableData[j][column];
                            if (attrValName == column2){
                                this.bzxx.tableData.splice(j,1);
                                j--;
                                flag=true;
                            }
                        }
                    }
                }
                return flag;
            },
            //添加属性值
            addValName_2(testDynamicIndex){
                let testDynamicAttrList = this.bzxx.testDynamicAttrList[testDynamicIndex];
                let attrType = testDynamicAttrList.attrType;
                let inputValName = testDynamicAttrList.attrValInputName;
                let attrName = testDynamicAttrList.attrName;
                let attrValSize = this.bzxx.testDynamicAttrList[testDynamicIndex].attrVal.length;
                if (inputValName === '' || inputValName.split(" ").join("").length==0){
                    this.msgError("属性值不能为空");
                    return
                }
                //判断属性值是否存在
                for (var items of this.bzxx.testDynamicAttrList[testDynamicIndex].attrVal) {
                    if (inputValName === items.attrValName){
                        this.msgError("已有重复的属性值");
                        this.$set(this.bzxx.testDynamicAttrList[testDynamicIndex],"attrValInputName",'');
                        return
                    }
                }
                //添加一个属性值
                this.bzxx.testDynamicAttrList[testDynamicIndex].attrVal.push(
                    {
                        attrValName: inputValName,
                        backupName: "",
                        checked: true,
                        colorCode: "#ffffff",
                        colorOrSize: attrType,
                        edit: false,
                        fontColor: "#434649",
                        id: null,
                        attrId:null,//只存固定的变种属性值ID,新增都是空;
                        picUrl: "",
                        sortNo: attrValSize,
                    }
                )
                this.true_deleteTableData(testDynamicIndex,this.bzxx.testDynamicAttrList[testDynamicIndex].attrVal.length-1);
                //重新描绘表格
                this.tableDataColumn(testDynamicIndex,inputValName);
            },
            getSPlatAttrId(){
                var param ={
                    'attrName':'Color',
                }
                var param_1 ={
                    'attrName':'Size',
                }
                getSPlatAttrId(param).then(res => {
                    this.bzxx.colorId = res.data
                }).catch(err => {});
                getSPlatAttrId(param_1).then(res => {
                    this.bzxx.sizeId = res.data
                }).catch(err => {});
            }
        },
        mounted() {
            this.sideBarTool();
        },
        computed: {
        },
    }
</script>

<style scoped>

    .time {
        font-size: 13px;
        color: #999;
    }

    .bottom {
        margin-top: 13px;
        line-height: 12px;
    }

    .button {
        padding: 0;
        float: right;
    }

    .image {
        width: 250px;
        height: 100px;
        display: block;
    }

    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }

    .clearfix:after {
        clear: both
    }

    #upload .el-upload-dragger {
        width: 136px;
        height: 106px;
    }
    #wlsz .el-table--border td{
        border-right: 0px solid #EBEEF5;
    }
</style>
<style scoped>
    .td_style {
        border-right: none;
        border-bottom: none;
    }
    .cursor >>> .el-icon-error:before{
        cursor: pointer;
    }
    .iconStyle >>> .el-icon-circle-plus-outline:before{
        color: #d0d3d6;
        cursor: not-allowed;
    }
    .spanStyle{
        display: inline-block;
        padding: 3px 20px;
        text-align: center;
        padding-top: 4px;
        margin-top: 10px;
        margin-left: -7px;
        border: 1px solid #e8e8e8;
    }
    .uploadBzxx >>> .el-upload-dragger{
        width: 95px;
        height: 100px;
    }
    .uploadBzxx >>> .el-icon-plus:before{
        font-size: 55px;
    }
    .uploadBzxx{
        margin-left: 4.16667%;
        margin-top: 15px;
    }
    .bzxxDeleIcon >>> .el-icon-error:before{
        font-size: 20px;
    }
    i:hover{
        color: deepskyblue;
        cursor: pointer;
    }
    /*超出长度用...标识*/
    .divOverflow{
        width: 90px;
        overflow: hidden;white-space: nowrap;text-overflow:ellipsis;
    }
    .iconStyle2 >>> .el-icon-circle-plus-outline:before{
        color: #4934b2;
        cursor: pointer;
    }
    /*锚点CSS*/
    #LoutiNav{position: fixed; top: 150px; right: 50px; display: none;}
    #LoutiNav li{ width: 80px; height: 30px; line-height: 30px; text-align: left; cursor: pointer;}
    #LoutiNav .active{ color: red;}
    .t_plane{ border-radius: 5px;margin: 10px auto;background-color: #ffffff;}
    ul,li,dl,ol{list-style: none;font-size: 12px;}
    /*锚点CSS结束*/
</style>

